import LocalizedStrings from 'react-localization';
import { Cookies } from 'react-cookie';

export const languages = [{ name: "English", locale: "en" },
{ name: "Español", locale: "es" },
{ name: "Français", locale: "fr" },
{ name: "中文", locale: "zh" },
{ name: "Português", locale: "pt" },
{ name: "Deutsch", locale: "de" },
{ name: "Русский", locale: "ru" },
{ name: "Українська", locale: "uk" }];



const translations = new LocalizedStrings({
    en: {
        leftRight: "Left <-> Right",
        beginIn: "Begin in",
        getReady: "Get ready",
        upAndDown: "Up <-> Down",
        appName: "Eye Fitness",
        motto: "Because healthy eyes shouldn't cost a thing.",
        mottoTagline: "Free vision training for a healthier world.",
        missionStatement: "Eye Fitness is built on a simple belief: health should be accessible to everyone, not just those who can afford it. Your vision is too important to be locked behind paywalls and subscriptions. That's why Eye Fitness is, and always will be, completely free. No trials, no premium features, no hidden costs—just effective eye training exercises available to anyone with an internet connection. Because when it comes to health, everyone deserves equal access.",
        privacyPolicy: "Privacy Policy",
        support: "App Support",
        supportEmail: "Email: support@eyefitness.ca",
        privacyPolicyPersonal: "Collection and Use of Personal Information",
        privacyPolicyPersonalText: "We don't collect and don't use any personal information.",
        privacyPolicyNonPersonal: "Collection and Use of Non Personal Information",
        privacyPolicyNonPersonalText: "We collect anonymous usage data (such as exercise completions and theme preferences) to help us improve the application. This data is not linked to your identity.",
        disclaimer: "Disclaimer: {0}",
        disclaimerTextPart1: "Please check with your Eye Doctor fist before starting exercises.\n" +
            " Contact lenses cannot be worn before, during, after doing exercises.\n" +
            " By continuing you agree to use this website at your own risk.",
        startExercise: "Pick your workout!",
        startExerciseDescription: "Beginners should start with Easy level once a day during one week. After then moderate as you feel.\n" +
            " You can pause any time by clicking on pause button or pressing 'space'.",
        easy: "Easy",
        medium: "Medium",
        tough: "Tough",
        intense: "Intense",
        rest: "Rest",
        blink: "Blink",
        next: "Next",
        skipToNext: "Skip to next exercise",
        finishedForToday: "You finished for today",
        circleRight: "Circle Right",
        circleLeft: "Circle Left",
        upLeft: "Up Left",
        upRight: "Up Right",
        downLeft: "Down Left",
        downRight: "Down Right",
        // Phase 1: New exercises
        figure8Horizontal: "Figure-8 Horizontal",
        figure8Vertical: "Figure-8 Vertical",
        blinkExercise: "Blink Exercise",
        slowCircleLeft: "Slow Circle Left",
        eyeRollComplete: "Eye Roll Complete",
        // Phase 2: Intermediate exercises
        squareClockwise: "Square Clockwise",
        squareCounterClockwise: "Square Counter-Clockwise",
        trianglePattern: "Triangle Pattern",
        starPattern: "Star Pattern",
        slowCircleRight: "Slow Circle Right",
        wavePattern: "Wave Pattern",
        // Exercise groups
        groupBasics: "Basics",
        groupBasicsDesc: "Original difficulty levels - perfect for getting started",
        groupProgressive: "Progressive",
        groupProgressiveDesc: "Enhanced workouts with advanced tracking patterns",
        progressiveEasy: "Progressive Easy",
        progressiveMedium: "Progressive Medium",
        progressiveTough: "Progressive Tough",
        geometricPatterns: "Geometric Patterns",
        selfTestTitle: "Eye Check",
        selfTestIntro: "How well can you see? Read the letters on screen and find out! Results are saved so you can track your progress over time.",
        selfTestQuickStart: "Start Eye Check",
        selfTestCalibrateFirst: "Calibrate Screen First",
        selfTestRecalibrate: "Recalibrate Screen",
        selfTestViewHistory: "My Results",
        selfTestCalibrationTitle: "Screen Calibration",
        selfTestCalibrationDesc: "Place a credit card or bank card flat against your screen. Drag or slide until the card on screen matches your real card exactly.",
        selfTestCreditCard: "CREDIT CARD",
        selfTestConfirmCalibration: "Looks Good!",
        selfTestBack: "Back",
        selfTestDistanceDesc: "How far are you from the screen?",
        selfTestEyeTitle: "Which Eye?",
        selfTestEyeDesc: "Pick which eye to test. Cover the other eye gently with your hand.",
        selfTestRightEye: "Right Eye",
        selfTestLeftEye: "Left Eye",
        selfTestBothEyes: "Both Eyes",
        selfTestEyeHint: "Tip: test each eye one at a time for best results.",
        selfTestDistanceReminder: "Stay at this distance:",
        selfTestCanYouRead: "Can you read these letters?",
        selfTestYes: "Yes",
        selfTestNo: "No",
        selfTestResultsTitle: "Your Score",
        selfTestDecimal: "Decimal",
        selfTestAcuity_excellent: "Super Vision!",
        selfTestAcuity_normal: "Great — 20/20 Vision!",
        selfTestAcuity_near_normal: "Good — Almost 20/20",
        selfTestAcuity_mild_impairment: "Fair — Could Be Better",
        selfTestAcuity_moderate: "Needs Attention",
        selfTestAcuity_significant: "See a Doctor",
        selfTestResultsDisclaimer: "This is just an estimate, not a doctor's exam. Visit an eye doctor for a proper check-up.",
        selfTestDisclaimerShort: "Not a medical test. See your eye doctor for a real exam.",
        selfTestTestAnotherEye: "Test Another Eye",
        selfTestDone: "Done",
        selfTestHistoryTitle: "My Results",
        selfTestNoHistory: "No tests yet! Take your first eye check to start tracking.",
        selfTestDate: "Date",
        selfTestStartNew: "New Eye Check",
        selfTestLastResults: "Your Latest Scores",
        selfTestTrendImproving: "Improving",
        selfTestTrendStable: "Stable",
        selfTestTrendDeclining: "Declining",
        builtInQuebec: "Designed in Quebec 🍁",
        peopleDriven: "People-driven. Community-focused. 100% Free.",
        disclaimerCompact: "Not medical advice. Consult your eye doctor before starting exercises.",
        sectionGames: "Games",
        sectionTraining: "Eye Training",
        sectionGamesDesc: "Train your eyes while having fun",
        sectionTrainingDesc: "Guided exercise routines",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "How fast are your eyes?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Climb with your eyes",
        dashboard: "Dashboard",
        progress: "Progress",
        currentStreak: "Current Streak",
        longestStreak: "Longest Streak",
        days: "days",
        totalSessions: "Total Sessions",
        completedDays: "Completed Days",
        totalPoints: "Total Points",
        points: "points",
        badges: "Badges",
        noBadges: "Complete exercises to earn badges!",
        // Badge names
        badge_first_session: "First Steps",
        badge_3_day_streak: "3-Day Streak",
        badge_7_day_streak: "Week Warrior",
        badge_14_day_streak: "Fortnight Focus",
        badge_30_day_streak: "Monthly Master",
        badge_60_day_streak: "Diamond Discipline",
        badge_365_day_streak: "Year of Vision",
        badge_10_sessions: "Dedicated",
        badge_25_sessions: "Quarter Century",
        badge_50_sessions: "Eye Champion",
        badge_100_sessions: "Vision Legend",
        badge_200_sessions: "Bicentennial",
        badge_100_points: "Century Score",
        badge_1000_points: "Point Master",
        badge_5000_points: "Elite Scorer",
        badge_explorer: "Explorer",
        badge_iron_eyes: "Iron Eyes",
        badge_pattern_pro: "Pattern Pro",
        badge_level_up: "Level Up",
        badge_overachiever: "Overachiever",
        badge_hat_trick: "Hat Trick",
        badge_comeback_kid: "Comeback Kid",
        badge_weekend_warrior: "Weekend Warrior",
        badge_eye_curious: "Eye Curious",
        badge_perfect_vision: "20/20 Club",
        badge_progress_watcher: "Progress Watcher",
        irisDashboardLegend: "A living legend of eye fitness!",
        activityCalendar: "Activity Calendar",
        lastSession: "Last Session",
        startTraining: "Start Training",
        continueTraining: "Continue Training",
        today: "Today",
        lesActivity: "Less",
        moreActivity: "More",
        // Theme and audio
        lightMode: "Switch to Light Mode",
        darkMode: "Switch to Dark Mode",
        sepiaMode: "Switch to Sepia Mode",
        audioOn: "Voice Guidance On",
        audioOff: "Voice Guidance Off",
        // Audio directions
        lookLeft: "Look left",
        lookRight: "Look right",
        lookUp: "Look up",
        lookDown: "Look down",
        lookCenter: "Center",
        lookUpLeft: "Look up left",
        lookUpRight: "Look up right",
        lookDownLeft: "Look down left",
        lookDownRight: "Look down right",
        relaxEyes: "Relax",
        // Homepage redesign
        startTrainingCta: "Start 5-Minute Training",
        socialProofUsers: "10,000+ users worldwide",
        socialProofFree: "100% Free Forever",
        socialProofPrivacy: "No Personal Data",
        // Features section
        featuresTitle: "Why Eye Fitness?",
        featureFreeTitle: "100% Free",
        featureFreeDesc: "No subscriptions, no premium features, no hidden costs.",
        featurePrivacyTitle: "Privacy First",
        featurePrivacyDesc: "We don't collect or store any personal data. Analytics are anonymous.",
        featureUniversalTitle: "Works Everywhere",
        featureUniversalDesc: "Use on any device with a web browser.",
        featureScienceTitle: "Science-Based",
        featureScienceDesc: "Exercises designed for effective eye muscle training.",
        // Enhanced exercise descriptions
        easyBenefit: "Perfect for beginners. Gentle movements to reduce strain.",
        mediumBenefit: "Build endurance with moderate intensity exercises.",
        toughBenefit: "Challenge yourself with advanced eye training.",
        intenseBenefit: "Maximum intensity for experienced practitioners.",
        exerciseCount: "{0} exercises",
        healthInfoTitle: "Important Health Information",
        // Avatar selector
        avatarSelector: "Choose Avatar",
        avatar_classic: "Classic Eyes",
        avatar_dog: "Dog",
        avatar_cat: "Cat",
        avatar_moose: "Moose",
        avatar_owl: "Owl",
        // IRIS mascot
        irisName: "Iris",
        irisGreetingFirst: "Hello! I'm Iris. Ready to train your eyes?",
        irisGreetingStreak: "Welcome back! {0}-day streak!",
        irisGreetingReturn: "Good to see you! Let's get training.",
        irisGreetingDone: "Great work today! Rest those eyes.",
        irisCompletionFirst: "Your eyes thank you! A great start.",
        irisCompletionStreak: "Day {0}! Keep the momentum going!",
        irisCompletionMilestone: "Incredible! {0} sessions completed!",
        irisCompletionNormal: "Well done! See you next time.",
        irisDashboardEmpty: "Start your first workout to begin!",
        irisDashboardLow: "You're building momentum. Keep going!",
        irisDashboardMedium: "What a week! Your eyes are getting stronger.",
        irisDashboardHigh: "{0}-day streak! You're on fire!",
        irisDashboardChampion: "A true eye fitness champion!",
        irisChatTitle: "Chat with Iris",
        irisChatWelcome: "Hoo-hoo! I'm Iris, your eye fitness owl! Ask me anything about eye health, or just say hi!",
        irisChatLoading: "Iris is waking up...",
        irisChatPlaceholder: "Ask Iris anything...",
        irisChatError: "Hoo... my feathers got ruffled! Try again?",
        irisChatNoWebGPU: "Iris needs a browser with WebGPU support (Chrome 113+ or Edge 113+). Try updating your browser!",
        irisChatLoadError: "Hoo... I couldn't wake up properly.",
        irisChatRetry: "Try Again",
        // Dashboard redesign
        thisWeek: "This Week",
        nextGoal: "Next Goal",
        badgesUnlocked: "{0} of {1} unlocked",
        dontBreakStreak: "Don't break your streak!",
        greatJobToday: "Great job today!",
        moreDaysStreak: "{0} more days for a {1}-Day Streak!",
        moreSessions: "{0} more sessions to earn '{1}'!",
        morePoints: "{0} more points to '{1}'!",
        todayDone: "Done for today",
        locked: "Locked",
        sessions: "sessions",
        // Auth & sync
        signIn: "Sign In",
        signOut: "Sign Out",
        synced: "Synced",
        syncHint: "Sign in to keep your progress across devices",
        nickname: "Nickname",
        nicknamePlaceholder: "Your nickname",
        comingSoon: "Cloud sync coming soon!",
    },
    es: {
        leftRight: "Izquierda <-> Derecha",
        beginIn: "Comenzar en",
        getReady: "Prepárate",
        upAndDown: "Arriba <-> Abajo",
        appName: "Fitness Ocular",
        motto: "Porque unos ojos sanos no deberían costar nada.",
        mottoTagline: "Entrenamiento visual gratuito para un mundo más saludable.",
        missionStatement: "Fitness Ocular se basa en una creencia simple: la salud debe ser accesible para todos, no solo para quienes pueden pagarla. Tu visión es demasiado importante para estar bloqueada detrás de muros de pago y suscripciones. Por eso Fitness Ocular es, y siempre será, completamente gratuito. Sin pruebas, sin funciones premium, sin costos ocultos—solo ejercicios efectivos para los ojos disponibles para cualquier persona con conexión a Internet. Porque cuando se trata de salud, todos merecen igualdad de acceso.",
        privacyPolicy: "Política de Privacidad",
        support: "Soporte de la Aplicación",
        supportEmail: "Correo electrónico: dev.samsklepal@gmail.com",
        privacyPolicyPersonal: "Recopilación y Uso de Información Personal",
        privacyPolicyPersonalText: "No recopilamos ni utilizamos ninguna información personal.",
        privacyPolicyNonPersonal: "Recopilación y Uso de Información No Personal",
        privacyPolicyNonPersonalText: "Recopilamos datos de uso anónimos (como ejercicios completados) para mejorar la aplicación. Estos datos no están vinculados a su identidad.",
        disclaimer: "Descargo de responsabilidad: {0}",
        disclaimerTextPart1: "Por favor, consulte con su oftalmólogo antes de comenzar los ejercicios.\n" +
            " No se pueden usar lentes de contacto antes, durante o después de hacer los ejercicios.\n" +
            " Al continuar, acepta usar este sitio web bajo su propio riesgo.",
        startExercise: "Elige tu entrenamiento!",
        startExerciseDescription: "Los principiantes deben comenzar con el nivel Fácil una vez al día durante una semana. Luego ajuste según se sienta.\n" +
            " Puede pausar en cualquier momento haciendo clic en el botón de pausa o presionando 'espacio'.",
        easy: "Fácil",
        medium: "Medio",
        tough: "Difícil",
        intense: "Intenso",
        rest: "Descanso",
        blink: "Parpadear",
        next: "Siguiente",
        skipToNext: "Saltar al siguiente ejercicio",
        finishedForToday: "Ha terminado por hoy",
        circleRight: "Círculo Derecha",
        circleLeft: "Círculo Izquierda",
        upLeft: "Arriba Izquierda",
        upRight: "Arriba Derecha",
        downLeft: "Abajo Izquierda",
        downRight: "Abajo Derecha",
        // Phase 1: New exercises
        figure8Horizontal: "Figura-8 Horizontal",
        figure8Vertical: "Figura-8 Vertical",
        blinkExercise: "Ejercicio de Parpadeo",
        slowCircleLeft: "Círculo Lento Izquierda",
        eyeRollComplete: "Rotación Ocular Completa",
        // Phase 2: Intermediate exercises
        squareClockwise: "Cuadrado Horario",
        squareCounterClockwise: "Cuadrado Antihorario",
        trianglePattern: "Patrón de Triángulo",
        starPattern: "Patrón de Estrella",
        slowCircleRight: "Círculo Lento Derecha",
        wavePattern: "Patrón de Onda",
        // Exercise groups
        groupBasics: "Básicos",
        groupBasicsDesc: "Niveles de dificultad originales - perfectos para comenzar",
        groupProgressive: "Progresivo",
        groupProgressiveDesc: "Entrenamientos mejorados con patrones de seguimiento avanzados",
        progressiveEasy: "Progresivo Fácil",
        progressiveMedium: "Progresivo Medio",
        progressiveTough: "Progresivo Difícil",
        geometricPatterns: "Patrones Geométricos",
        selfTestTitle: "Revisión de Ojos",
        selfTestIntro: "¿Qué tan bien ves? ¡Lee las letras en pantalla y descúbrelo! Los resultados se guardan para que puedas seguir tu progreso.",
        selfTestQuickStart: "Comenzar Revisión",
        selfTestCalibrateFirst: "Calibrar Pantalla Primero",
        selfTestRecalibrate: "Recalibrar Pantalla",
        selfTestViewHistory: "Mis Resultados",
        selfTestCalibrationTitle: "Calibración de Pantalla",
        selfTestCalibrationDesc: "Pon una tarjeta de crédito o bancaria sobre tu pantalla. Arrastra o desliza hasta que la tarjeta en pantalla sea del mismo tamaño que tu tarjeta real.",
        selfTestCreditCard: "TARJETA DE CRÉDITO",
        selfTestConfirmCalibration: "¡Se Ve Bien!",
        selfTestBack: "Atrás",
        selfTestDistanceDesc: "¿A qué distancia estás de la pantalla?",
        selfTestEyeTitle: "¿Cuál Ojo?",
        selfTestEyeDesc: "Elige qué ojo quieres revisar. Tapa el otro ojo suavemente con la mano.",
        selfTestRightEye: "Ojo Derecho",
        selfTestLeftEye: "Ojo Izquierdo",
        selfTestBothEyes: "Ambos Ojos",
        selfTestEyeHint: "Consejo: revisa cada ojo por separado para mejores resultados.",
        selfTestDistanceReminder: "Quédate a esta distancia:",
        selfTestCanYouRead: "¿Puedes leer estas letras?",
        selfTestYes: "Sí",
        selfTestNo: "No",
        selfTestResultsTitle: "Tu Puntuación",
        selfTestDecimal: "Decimal",
        selfTestAcuity_excellent: "¡Súper Visión!",
        selfTestAcuity_normal: "¡Genial — Visión 20/20!",
        selfTestAcuity_near_normal: "Bien — Casi 20/20",
        selfTestAcuity_mild_impairment: "Regular — Podría Mejorar",
        selfTestAcuity_moderate: "Necesita Atención",
        selfTestAcuity_significant: "Visita al Doctor",
        selfTestResultsDisclaimer: "Esto es solo un cálculo aproximado, no un examen médico. Visita a un oculista para una revisión completa.",
        selfTestDisclaimerShort: "No es un examen médico. Consulta a tu oculista para una revisión real.",
        selfTestTestAnotherEye: "Revisar Otro Ojo",
        selfTestDone: "Listo",
        selfTestHistoryTitle: "Mis Resultados",
        selfTestNoHistory: "¡Aún no hay pruebas! Haz tu primera revisión para empezar a seguir tu progreso.",
        selfTestDate: "Fecha",
        selfTestStartNew: "Nueva Revisión",
        selfTestLastResults: "Tus Últimos Resultados",
        selfTestTrendImproving: "Mejorando",
        selfTestTrendStable: "Estable",
        selfTestTrendDeclining: "Bajando",
        builtInQuebec: "Diseñado en Quebec 🍁",
        peopleDriven: "Dirigido por personas. Enfocado en la comunidad. 100% Gratuito.",
        disclaimerCompact: "No es consejo médico. Consulte a su oftalmólogo antes de comenzar los ejercicios.",
        sectionGames: "Juegos",
        sectionTraining: "Entrenamiento Ocular",
        sectionGamesDesc: "Entrena tus ojos mientras te diviertes",
        sectionTrainingDesc: "Rutinas de ejercicios guiados",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "¿Qué tan rápidos son tus ojos?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Escala con tus ojos",
        dashboard: "Panel de Control",
        progress: "Progreso",
        currentStreak: "Racha Actual",
        longestStreak: "Racha Más Larga",
        days: "días",
        totalSessions: "Sesiones Totales",
        completedDays: "Días Completados",
        totalPoints: "Puntos Totales",
        points: "puntos",
        badges: "Insignias",
        noBadges: "¡Completa ejercicios para ganar insignias!",
        badge_first_session: "Primeros Pasos",
        badge_3_day_streak: "Racha de 3 Días",
        badge_7_day_streak: "Guerrero Semanal",
        badge_14_day_streak: "Foco Quincenal",
        badge_30_day_streak: "Maestro Mensual",
        badge_60_day_streak: "Disciplina Diamante",
        badge_365_day_streak: "Año de Visión",
        badge_10_sessions: "Dedicado",
        badge_25_sessions: "Cuarto de Siglo",
        badge_50_sessions: "Campeón Ocular",
        badge_100_sessions: "Leyenda Visual",
        badge_200_sessions: "Bicentenario",
        badge_100_points: "Puntuación Centenaria",
        badge_1000_points: "Maestro de Puntos",
        badge_5000_points: "Anotador Élite",
        badge_explorer: "Explorador",
        badge_iron_eyes: "Ojos de Hierro",
        badge_pattern_pro: "Pro de Patrones",
        badge_level_up: "Subir de Nivel",
        badge_overachiever: "Sobresaliente",
        badge_hat_trick: "Triplete",
        badge_comeback_kid: "Regreso Triunfal",
        badge_weekend_warrior: "Guerrero de Fin de Semana",
        badge_eye_curious: "Ojos Curiosos",
        badge_perfect_vision: "Club 20/20",
        badge_progress_watcher: "Observador de Progreso",
        irisDashboardLegend: "¡Una leyenda viviente del fitness ocular!",
        activityCalendar: "Calendario de Actividad",
        lastSession: "Última Sesión",
        startTraining: "Comenzar Entrenamiento",
        continueTraining: "Continuar Entrenamiento",
        today: "Hoy",
        lesActivity: "Menos",
        moreActivity: "Más",
        // Theme and audio
        lightMode: "Cambiar a Modo Claro",
        darkMode: "Cambiar a Modo Oscuro",
        sepiaMode: "Cambiar a Modo Sepia",
        audioOn: "Guía de Voz Activada",
        audioOff: "Guía de Voz Desactivada",
        // Audio directions
        lookLeft: "Mira a la izquierda",
        lookRight: "Mira a la derecha",
        lookUp: "Mira hacia arriba",
        lookDown: "Mira hacia abajo",
        lookCenter: "Centro",
        lookUpLeft: "Mira arriba a la izquierda",
        lookUpRight: "Mira arriba a la derecha",
        lookDownLeft: "Mira abajo a la izquierda",
        lookDownRight: "Mira abajo a la derecha",
        relaxEyes: "Relájate",
        // Homepage redesign
        startTrainingCta: "Iniciar entrenamiento de 5 minutos",
        socialProofUsers: "10,000+ usuarios en todo el mundo",
        socialProofFree: "100% Gratis para siempre",
        socialProofPrivacy: "Sin datos personales",
        // Features section
        featuresTitle: "¿Por qué Fitness Ocular?",
        featureFreeTitle: "100% Gratis",
        featureFreeDesc: "Sin suscripciones, sin funciones premium, sin costos ocultos.",
        featurePrivacyTitle: "Privacidad primero",
        featurePrivacyDesc: "No recopilamos datos personales. Los análisis son anónimos.",
        featureUniversalTitle: "Funciona en todas partes",
        featureUniversalDesc: "Úsalo en cualquier dispositivo con navegador web.",
        featureScienceTitle: "Basado en ciencia",
        featureScienceDesc: "Ejercicios diseñados para entrenar eficazmente los músculos oculares.",
        // Enhanced exercise descriptions
        easyBenefit: "Perfecto para principiantes. Movimientos suaves para reducir la tensión.",
        mediumBenefit: "Desarrolla resistencia con ejercicios de intensidad moderada.",
        toughBenefit: "Desafíate con entrenamiento ocular avanzado.",
        intenseBenefit: "Máxima intensidad para practicantes experimentados.",
        exerciseCount: "{0} ejercicios",
        healthInfoTitle: "Información de salud importante",
        // Avatar selector
        avatarSelector: "Elegir Avatar",
        avatar_classic: "Ojos Clásicos",
        avatar_dog: "Perro",
        avatar_cat: "Gato",
        avatar_moose: "Alce",
        avatar_owl: "Búho",
        // IRIS mascot
        irisName: "Iris",
        irisGreetingFirst: "¡Hola! Soy Iris. ¿Listo para entrenar tus ojos?",
        irisGreetingStreak: "¡Bienvenido! ¡Racha de {0} días!",
        irisGreetingReturn: "¡Qué bueno verte! A entrenar.",
        irisGreetingDone: "¡Gran trabajo hoy! Descansa los ojos.",
        irisCompletionFirst: "¡Tus ojos te lo agradecen! Un gran comienzo.",
        irisCompletionStreak: "¡Día {0}! ¡Sigue así!",
        irisCompletionMilestone: "¡Increíble! ¡{0} sesiones completadas!",
        irisCompletionNormal: "¡Bien hecho! Nos vemos la próxima.",
        irisDashboardEmpty: "¡Comienza tu primer entrenamiento!",
        irisDashboardLow: "Estás ganando impulso. ¡Sigue!",
        irisDashboardMedium: "¡Qué semana! Tus ojos se fortalecen.",
        irisDashboardHigh: "¡Racha de {0} días! ¡Estás en llamas!",
        irisDashboardChampion: "¡Un verdadero campeón del fitness ocular!",
        irisChatTitle: "Chatear con Iris",
        irisChatWelcome: "¡Hoo-hoo! ¡Soy Iris, tu búho de fitness ocular! ¡Pregúntame sobre salud visual o solo saluda!",
        irisChatLoading: "Iris está despertando...",
        irisChatPlaceholder: "Pregunta a Iris...",
        irisChatError: "Hoo... ¡se me alborotaron las plumas! ¿Intentamos de nuevo?",
        irisChatNoWebGPU: "Iris necesita un navegador con soporte WebGPU (Chrome 113+ o Edge 113+). ¡Intenta actualizar tu navegador!",
        irisChatLoadError: "Hoo... no pude despertar bien.",
        irisChatRetry: "Intentar de nuevo",
        thisWeek: "Esta Semana",
        nextGoal: "Siguiente Meta",
        badgesUnlocked: "{0} de {1} desbloqueadas",
        dontBreakStreak: "¡No pierdas tu racha!",
        greatJobToday: "¡Buen trabajo hoy!",
        moreDaysStreak: "¡{0} días más para una racha de {1} días!",
        moreSessions: "¡{0} sesiones más para ganar '{1}'!",
        morePoints: "¡{0} puntos más para '{1}'!",
        todayDone: "Hecho por hoy",
        locked: "Bloqueada",
        sessions: "sesiones",
        signIn: "Iniciar sesión",
        signOut: "Cerrar sesión",
        synced: "Sincronizado",
        syncHint: "Inicia sesión para guardar tu progreso en todos tus dispositivos",
        nickname: "Apodo",
        nicknamePlaceholder: "Tu apodo",
        comingSoon: "Sincronización en la nube próximamente!",
    },
    fr: {
        leftRight: "Gauche <-> Droite",
        beginIn: "Début dans",
        getReady: "Préparez-vous",
        upAndDown: "Haut <-> Bas",
        appName: "Conditionnement Oculaire",
        motto: "Parce que des yeux en santé ne devraient rien coûter.",
        mottoTagline: "Entraînement visuel gratuit pour un monde en meilleure santé.",
        missionStatement: "Conditionnement Oculaire repose sur une conviction simple : la santé devrait être accessible à tous, pas seulement à ceux qui en ont les moyens. Votre vision est trop importante pour être verrouillée derrière des abonnements payants. C'est pourquoi Conditionnement Oculaire est, et sera toujours, entièrement gratuit. Aucun essai, aucune fonctionnalité premium, aucun coût caché—juste des exercices efficaces pour les yeux, disponibles pour toute personne ayant une connexion Internet. Parce que lorsqu'il s'agit de santé, chacun mérite un accès égal.",
        privacyPolicy: "Politique de confidentialité",
        support: "Assistance de l'application",
        supportEmail: "Courriel : dev.samsklepal@gmail.com",
        privacyPolicyPersonal: "Collecte et utilisation des informations personnelles",
        privacyPolicyPersonalText: "Nous ne collectons ni n'utilisons aucune information personnelle.",
        privacyPolicyNonPersonal: "Collecte et utilisation des informations non personnelles",
        privacyPolicyNonPersonalText: "Nous collectons des données d'utilisation anonymes (comme les exercices complétés) pour améliorer l'application. Ces données ne sont pas liées à votre identité.",
        disclaimer: "Avertissement : {0}",
        disclaimerTextPart1: "Veuillez consulter votre ophtalmologiste avant de commencer les exercices.\n" +
            " Les lentilles de contact ne peuvent pas être portées avant, pendant ou après les exercices.\n" +
            " En continuant, vous acceptez d'utiliser ce site Web à vos propres risques.",
        startExercise: "Choisis ton entraînement!",
        startExerciseDescription: "Les débutants devraient commencer avec le niveau Facile une fois par jour pendant une semaine. Ensuite, ajustez selon votre ressenti.\n" +
            " Vous pouvez mettre en pause à tout moment en cliquant sur le bouton pause ou en appuyant sur 'espace'.",
        easy: "Facile",
        medium: "Moyen",
        tough: "Difficile",
        intense: "Intense",
        rest: "Repos",
        blink: "Cligner",
        next: "Suivant",
        skipToNext: "Passer à l'exercice suivant",
        finishedForToday: "Vous avez terminé pour aujourd'hui",
        circleRight: "Cercle droite",
        circleLeft: "Cercle gauche",
        upLeft: "Haut gauche",
        upRight: "Haut droite",
        downLeft: "Bas gauche",
        downRight: "Bas droite",
        // Phase 1: New exercises
        figure8Horizontal: "Figure-8 Horizontal",
        figure8Vertical: "Figure-8 Vertical",
        blinkExercise: "Exercice de Clignement",
        slowCircleLeft: "Cercle Lent Gauche",
        eyeRollComplete: "Rotation Oculaire Complète",
        // Phase 2: Intermediate exercises
        squareClockwise: "Carré Sens Horaire",
        squareCounterClockwise: "Carré Sens Antihoraire",
        trianglePattern: "Motif Triangle",
        starPattern: "Motif Étoile",
        slowCircleRight: "Cercle Lent Droite",
        wavePattern: "Motif Vague",
        // Exercise groups
        groupBasics: "Basiques",
        groupBasicsDesc: "Niveaux de difficulté d'origine - parfaits pour commencer",
        groupProgressive: "Progressif",
        groupProgressiveDesc: "Entraînements améliorés avec motifs de suivi avancés",
        progressiveEasy: "Progressif Facile",
        progressiveMedium: "Progressif Moyen",
        progressiveTough: "Progressif Difficile",
        geometricPatterns: "Motifs Géométriques",
        selfTestTitle: "Bilan des Yeux",
        selfTestIntro: "Tu vois bien ? Lis les lettres à l'écran pour le savoir ! Les résultats sont enregistrés pour suivre tes progrès.",
        selfTestQuickStart: "Commencer le Bilan",
        selfTestCalibrateFirst: "Calibrer l'Écran d'Abord",
        selfTestRecalibrate: "Recalibrer l'Écran",
        selfTestViewHistory: "Mes Résultats",
        selfTestCalibrationTitle: "Calibration de l'Écran",
        selfTestCalibrationDesc: "Place une carte de crédit ou bancaire à plat contre ton écran. Glisse ou ajuste jusqu'à ce que la carte à l'écran soit exactement de la même taille que ta vraie carte.",
        selfTestCreditCard: "CARTE DE CRÉDIT",
        selfTestConfirmCalibration: "C'est Bon !",
        selfTestBack: "Retour",
        selfTestDistanceDesc: "À quelle distance es-tu de l'écran ?",
        selfTestEyeTitle: "Quel Œil ?",
        selfTestEyeDesc: "Choisis quel œil tu veux tester. Couvre l'autre œil doucement avec ta main.",
        selfTestRightEye: "Œil Droit",
        selfTestLeftEye: "Œil Gauche",
        selfTestBothEyes: "Les Deux Yeux",
        selfTestEyeHint: "Astuce : teste chaque œil séparément pour de meilleurs résultats.",
        selfTestDistanceReminder: "Reste à cette distance :",
        selfTestCanYouRead: "Tu arrives à lire ces lettres ?",
        selfTestYes: "Oui",
        selfTestNo: "Non",
        selfTestResultsTitle: "Ton Score",
        selfTestDecimal: "Décimal",
        selfTestAcuity_excellent: "Super Vision !",
        selfTestAcuity_normal: "Génial — Vision 20/20 !",
        selfTestAcuity_near_normal: "Bien — Presque 20/20",
        selfTestAcuity_mild_impairment: "Pas Mal — Peut Mieux Faire",
        selfTestAcuity_moderate: "À Surveiller",
        selfTestAcuity_significant: "Consulte un Docteur",
        selfTestResultsDisclaimer: "Ceci est une estimation, pas un examen médical. Consulte un ophtalmologue pour un vrai bilan.",
        selfTestDisclaimerShort: "Ce n'est pas un examen médical. Consulte ton ophtalmologue pour un vrai bilan.",
        selfTestTestAnotherEye: "Tester un Autre Œil",
        selfTestDone: "Terminé",
        selfTestHistoryTitle: "Mes Résultats",
        selfTestNoHistory: "Pas encore de tests ! Fais ton premier bilan pour commencer à suivre tes progrès.",
        selfTestDate: "Date",
        selfTestStartNew: "Nouveau Bilan",
        selfTestLastResults: "Tes Derniers Scores",
        selfTestTrendImproving: "En Progrès",
        selfTestTrendStable: "Stable",
        selfTestTrendDeclining: "En Baisse",
        builtInQuebec: "Conçu au Québec 🍁",
        peopleDriven: "Axé sur les gens. Axé sur la communauté. 100% gratuit.",
        disclaimerCompact: "Ne constitue pas un avis médical. Consultez votre ophtalmologiste avant de commencer les exercices.",
        sectionGames: "Jeux",
        sectionTraining: "Entraînement Oculaire",
        sectionGamesDesc: "Entraînez vos yeux en vous amusant",
        sectionTrainingDesc: "Routines d'exercices guidés",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "Vos yeux sont-ils rapides ?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Grimpez avec vos yeux",
        dashboard: "Tableau de bord",
        progress: "Progrès",
        currentStreak: "Série actuelle",
        longestStreak: "Série la plus longue",
        days: "jours",
        totalSessions: "Sessions totales",
        completedDays: "Jours complétés",
        totalPoints: "Points totaux",
        points: "points",
        badges: "Insignes",
        noBadges: "Complétez des exercices pour gagner des insignes !",
        badge_first_session: "Premiers Pas",
        badge_3_day_streak: "Série de 3 Jours",
        badge_7_day_streak: "Guerrier de la Semaine",
        badge_14_day_streak: "Focus Bimensuel",
        badge_30_day_streak: "Maître Mensuel",
        badge_60_day_streak: "Discipline de Diamant",
        badge_365_day_streak: "Année de Vision",
        badge_10_sessions: "Dévoué",
        badge_25_sessions: "Quart de Siècle",
        badge_50_sessions: "Champion des Yeux",
        badge_100_sessions: "Légende Visuelle",
        badge_200_sessions: "Bicentenaire",
        badge_100_points: "Score du Siècle",
        badge_1000_points: "Maître des Points",
        badge_5000_points: "Marqueur d'Élite",
        badge_explorer: "Explorateur",
        badge_iron_eyes: "Yeux de Fer",
        badge_pattern_pro: "Pro des Motifs",
        badge_level_up: "Progression",
        badge_overachiever: "Surpassement",
        badge_hat_trick: "Coup du Chapeau",
        badge_comeback_kid: "Retour Triomphal",
        badge_weekend_warrior: "Guerrier du Week-end",
        badge_eye_curious: "Yeux Curieux",
        badge_perfect_vision: "Club 20/20",
        badge_progress_watcher: "Observateur de Progrès",
        irisDashboardLegend: "Une légende vivante du fitness oculaire!",
        activityCalendar: "Calendrier d'activité",
        lastSession: "Dernière session",
        startTraining: "Commencer l'entraînement",
        continueTraining: "Continuer l'entraînement",
        today: "Aujourd'hui",
        lesActivity: "Moins",
        moreActivity: "Plus",
        // Theme and audio
        lightMode: "Passer au mode clair",
        darkMode: "Passer au mode sombre",
        sepiaMode: "Passer au mode sépia",
        audioOn: "Guidage vocal activé",
        audioOff: "Guidage vocal désactivé",
        // Audio directions
        lookLeft: "Regardez à gauche",
        lookRight: "Regardez à droite",
        lookUp: "Regardez en haut",
        lookDown: "Regardez en bas",
        lookCenter: "Centre",
        lookUpLeft: "Regardez en haut à gauche",
        lookUpRight: "Regardez en haut à droite",
        lookDownLeft: "Regardez en bas à gauche",
        lookDownRight: "Regardez en bas à droite",
        relaxEyes: "Détendez-vous",
        // Homepage redesign
        startTrainingCta: "Commencer 5 minutes d'entraînement",
        socialProofUsers: "10 000+ utilisateurs dans le monde",
        socialProofFree: "100% Gratuit pour toujours",
        socialProofPrivacy: "Aucune donnée personnelle",
        // Features section
        featuresTitle: "Pourquoi Eye Fitness ?",
        featureFreeTitle: "100% Gratuit",
        featureFreeDesc: "Aucun abonnement, aucune fonctionnalité premium, aucun coût caché.",
        featurePrivacyTitle: "Vie privée d'abord",
        featurePrivacyDesc: "Nous ne collectons aucune donnée personnelle. Les analyses sont anonymes.",
        featureUniversalTitle: "Fonctionne partout",
        featureUniversalDesc: "Utilisez sur n'importe quel appareil avec un navigateur web.",
        featureScienceTitle: "Basé sur la science",
        featureScienceDesc: "Exercices conçus pour un entraînement efficace des muscles oculaires.",
        // Enhanced exercise descriptions
        easyBenefit: "Parfait pour les débutants. Mouvements doux pour réduire la fatigue.",
        mediumBenefit: "Développez l'endurance avec des exercices d'intensité modérée.",
        toughBenefit: "Défiez-vous avec un entraînement oculaire avancé.",
        intenseBenefit: "Intensité maximale pour les pratiquants expérimentés.",
        exerciseCount: "{0} exercices",
        healthInfoTitle: "Informations de santé importantes",
        // Avatar selector
        avatarSelector: "Choisir un Avatar",
        avatar_classic: "Yeux Classiques",
        avatar_dog: "Chien",
        avatar_cat: "Chat",
        avatar_moose: "Orignal",
        avatar_owl: "Hibou",
        // IRIS mascot
        irisName: "Iris",
        irisGreetingFirst: "Bonjour! Je suis Iris. Prêt à entraîner vos yeux?",
        irisGreetingStreak: "Bon retour! Série de {0} jours!",
        irisGreetingReturn: "Content de vous revoir! On s'entraîne.",
        irisGreetingDone: "Excellent travail aujourd'hui! Reposez vos yeux.",
        irisCompletionFirst: "Vos yeux vous remercient! Un excellent début.",
        irisCompletionStreak: "Jour {0}! Gardez l'élan!",
        irisCompletionMilestone: "Incroyable! {0} sessions complétées!",
        irisCompletionNormal: "Bien joué! À la prochaine.",
        irisDashboardEmpty: "Commencez votre premier entraînement!",
        irisDashboardLow: "L'élan se construit. Continuez!",
        irisDashboardMedium: "Quelle semaine! Vos yeux se renforcent.",
        irisDashboardHigh: "Série de {0} jours! Vous êtes en feu!",
        irisDashboardChampion: "Un vrai champion du fitness oculaire!",
        irisChatTitle: "Discuter avec Iris",
        irisChatWelcome: "Hou-hou! Je suis Iris, votre hibou fitness oculaire! Posez-moi vos questions sur la santé des yeux!",
        irisChatLoading: "Iris se réveille...",
        irisChatPlaceholder: "Demandez à Iris...",
        irisChatError: "Hou... mes plumes se sont ébouriffées! On réessaie?",
        irisChatNoWebGPU: "Iris a besoin d'un navigateur avec support WebGPU (Chrome 113+ ou Edge 113+). Essayez de mettre à jour!",
        irisChatLoadError: "Hou... je n'ai pas pu me réveiller correctement.",
        irisChatRetry: "Réessayer",
        thisWeek: "Cette Semaine",
        nextGoal: "Prochain Objectif",
        badgesUnlocked: "{0} sur {1} débloqués",
        dontBreakStreak: "Ne brisez pas votre série!",
        greatJobToday: "Bravo aujourd'hui!",
        moreDaysStreak: "Encore {0} jours pour une série de {1} jours!",
        moreSessions: "Encore {0} sessions pour obtenir '{1}'!",
        morePoints: "Encore {0} points pour '{1}'!",
        todayDone: "Terminé pour aujourd'hui",
        locked: "Verrouillé",
        sessions: "sessions",
        signIn: "Se connecter",
        signOut: "Se déconnecter",
        synced: "Synchronisé",
        syncHint: "Connectez-vous pour garder votre progression sur tous vos appareils",
        nickname: "Surnom",
        nicknamePlaceholder: "Votre surnom",
        comingSoon: "Synchronisation cloud bientôt disponible!",
    },
    zh: {
        leftRight: "左 <-> 右",
        beginIn: "开始倒计时",
        getReady: "准备好",
        upAndDown: "上 <-> 下",
        appName: "眼睛健身",
        motto: "因为健康的眼睛不应该花钱。",
        mottoTagline: "免费的视力训练，让世界更健康。",
        missionStatement: "眼睛健身基于一个简单的信念：健康应该对每个人都可及，而不仅仅是那些负担得起的人。您的视力太重要了，不应该被付费墙和订阅所阻挡。这就是为什么眼睛健身现在和将来都是完全免费的。没有试用版，没有高级功能，没有隐藏费用——只有有效的眼部训练，任何有互联网连接的人都可以使用。因为健康面前，人人平等。",
        privacyPolicy: "隐私政策",
        support: "应用支持",
        supportEmail: "邮箱：support@eyefitness.ca",
        privacyPolicyPersonal: "个人信息的收集和使用",
        privacyPolicyPersonalText: "我们不收集也不使用任何个人信息。",
        privacyPolicyNonPersonal: "非个人信息的收集和使用",
        privacyPolicyNonPersonalText: "我们收集匿名使用数据（如完成的练习）以改进应用程序。这些数据与您的身份无关。",
        disclaimer: "免责声明：{0}",
        disclaimerTextPart1: "请在开始练习之前咨询您的眼科医生。\n练习前、中、后不能佩戴隐形眼镜。\n继续即表示您同意自行承担使用本网站的风险。",
        startExercise: "选择你的训练！",
        startExerciseDescription: "初学者应从简单级别开始，每天一次，持续一周。之后根据感觉调整。\n您可以随时点击暂停按钮或按'空格键'暂停。",
        easy: "简单",
        medium: "中等",
        tough: "困难",
        intense: "高强度",
        rest: "休息",
        blink: "眨眼",
        next: "下一个",
        skipToNext: "跳到下一个练习",
        finishedForToday: "今天的练习完成了",
        circleRight: "顺时针转圈",
        circleLeft: "逆时针转圈",
        upLeft: "左上",
        upRight: "右上",
        downLeft: "左下",
        downRight: "右下",
        figure8Horizontal: "水平八字",
        figure8Vertical: "垂直八字",
        blinkExercise: "眨眼练习",
        slowCircleLeft: "慢速左转",
        eyeRollComplete: "完整转眼",
        squareClockwise: "顺时针方形",
        squareCounterClockwise: "逆时针方形",
        trianglePattern: "三角形图案",
        starPattern: "星形图案",
        slowCircleRight: "慢速右转",
        wavePattern: "波浪图案",
        groupBasics: "基础",
        groupBasicsDesc: "原始难度级别——非常适合入门",
        groupProgressive: "进阶",
        groupProgressiveDesc: "带有高级追踪模式的增强训练",
        progressiveEasy: "进阶简单",
        progressiveMedium: "进阶中等",
        progressiveTough: "进阶困难",
        geometricPatterns: "几何图案",
        selfTestTitle: "视力检查",
        selfTestIntro: "你能看多清楚？读出屏幕上的字母来测试！结果会保存，方便你跟踪进度。",
        selfTestQuickStart: "开始视力检查",
        selfTestCalibrateFirst: "先校准屏幕",
        selfTestRecalibrate: "重新校准屏幕",
        selfTestViewHistory: "我的结果",
        selfTestCalibrationTitle: "屏幕校准",
        selfTestCalibrationDesc: "将信用卡或银行卡平放在屏幕上。拖动或滑动，直到屏幕上的卡片与真实卡片完全匹配。",
        selfTestCreditCard: "信用卡",
        selfTestConfirmCalibration: "看起来不错！",
        selfTestBack: "返回",
        selfTestDistanceDesc: "你离屏幕有多远？",
        selfTestEyeTitle: "哪只眼睛？",
        selfTestEyeDesc: "选择要测试的眼睛。用手轻轻遮住另一只眼睛。",
        selfTestRightEye: "右眼",
        selfTestLeftEye: "左眼",
        selfTestBothEyes: "双眼",
        selfTestEyeHint: "提示：分别测试每只眼睛效果最好。",
        selfTestDistanceReminder: "保持这个距离：",
        selfTestCanYouRead: "你能读出这些字母吗？",
        selfTestYes: "能",
        selfTestNo: "不能",
        selfTestResultsTitle: "你的成绩",
        selfTestDecimal: "小数",
        selfTestAcuity_excellent: "超级视力！",
        selfTestAcuity_normal: "棒极了——20/20视力！",
        selfTestAcuity_near_normal: "不错——接近20/20",
        selfTestAcuity_mild_impairment: "一般——还能更好",
        selfTestAcuity_moderate: "需要关注",
        selfTestAcuity_significant: "建议就医",
        selfTestResultsDisclaimer: "这只是估计值，不是医生检查。请到眼科医生那里做正式检查。",
        selfTestDisclaimerShort: "非医学测试。请到眼科医生那里做正式检查。",
        selfTestTestAnotherEye: "测试另一只眼睛",
        selfTestDone: "完成",
        selfTestHistoryTitle: "我的结果",
        selfTestNoHistory: "还没有测试记录！进行第一次视力检查开始追踪。",
        selfTestDate: "日期",
        selfTestStartNew: "新的视力检查",
        selfTestLastResults: "最新成绩",
        selfTestTrendImproving: "正在改善",
        selfTestTrendStable: "稳定",
        selfTestTrendDeclining: "有所下降",
        builtInQuebec: "魁北克设计 🍁",
        peopleDriven: "以人为本。社区驱动。100%免费。",
        disclaimerCompact: "非医疗建议。开始练习前请咨询眼科医生。",
        sectionGames: "游戏",
        sectionTraining: "眼部训练",
        sectionGamesDesc: "边玩边训练你的眼睛",
        sectionTrainingDesc: "指导性锻炼计划",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "你的眼睛有多快？",
        rockClimber: "Rock Climber",
        rockClimberDesc: "用眼睛攀岩",
        dashboard: "仪表盘",
        progress: "进度",
        currentStreak: "当前连续",
        longestStreak: "最长连续",
        days: "天",
        totalSessions: "总训练次数",
        completedDays: "完成天数",
        totalPoints: "总积分",
        points: "积分",
        badges: "徽章",
        noBadges: "完成练习即可获得徽章！",
        badge_first_session: "第一步",
        badge_3_day_streak: "连续3天",
        badge_7_day_streak: "一周勇士",
        badge_14_day_streak: "两周专注",
        badge_30_day_streak: "月度大师",
        badge_60_day_streak: "钻石意志",
        badge_365_day_streak: "视力之年",
        badge_10_sessions: "坚持不懈",
        badge_25_sessions: "25次里程碑",
        badge_50_sessions: "眼睛冠军",
        badge_100_sessions: "视力传奇",
        badge_200_sessions: "双百达成",
        badge_100_points: "百分达人",
        badge_1000_points: "积分大师",
        badge_5000_points: "精英玩家",
        badge_explorer: "探索者",
        badge_iron_eyes: "钢铁之眼",
        badge_pattern_pro: "图案达人",
        badge_level_up: "升级",
        badge_overachiever: "超额完成",
        badge_hat_trick: "帽子戏法",
        badge_comeback_kid: "王者归来",
        badge_weekend_warrior: "周末战士",
        badge_eye_curious: "好奇之眼",
        badge_perfect_vision: "20/20俱乐部",
        badge_progress_watcher: "进度观察者",
        irisDashboardLegend: "眼睛健身的活传奇！",
        activityCalendar: "活动日历",
        lastSession: "上次训练",
        startTraining: "开始训练",
        continueTraining: "继续训练",
        today: "今天",
        lesActivity: "较少",
        moreActivity: "较多",
        lightMode: "切换到浅色模式",
        darkMode: "切换到深色模式",
        sepiaMode: "切换到护眼模式",
        audioOn: "语音引导已开启",
        audioOff: "语音引导已关闭",
        lookLeft: "看左边",
        lookRight: "看右边",
        lookUp: "看上面",
        lookDown: "看下面",
        lookCenter: "看中间",
        lookUpLeft: "看左上",
        lookUpRight: "看右上",
        lookDownLeft: "看左下",
        lookDownRight: "看右下",
        relaxEyes: "放松",
        startTrainingCta: "开始5分钟训练",
        socialProofUsers: "全球10,000+用户",
        socialProofFree: "永久100%免费",
        socialProofPrivacy: "无个人数据收集",
        featuresTitle: "为什么选择眼睛健身？",
        featureFreeTitle: "100%免费",
        featureFreeDesc: "无订阅，无高级功能，无隐藏费用。",
        featurePrivacyTitle: "隐私第一",
        featurePrivacyDesc: "我们不收集个人数据。分析完全匿名。",
        featureUniversalTitle: "随处可用",
        featureUniversalDesc: "在任何有浏览器的设备上使用。",
        featureScienceTitle: "科学依据",
        featureScienceDesc: "专为有效眼肌训练设计的练习。",
        easyBenefit: "非常适合初学者。轻柔动作缓解疲劳。",
        mediumBenefit: "中等强度练习提升耐力。",
        toughBenefit: "高级眼部训练挑战自我。",
        intenseBenefit: "面向有经验者的最高强度。",
        exerciseCount: "{0}个练习",
        healthInfoTitle: "重要健康信息",
        avatarSelector: "选择头像",
        avatar_classic: "经典眼睛",
        avatar_dog: "小狗",
        avatar_cat: "小猫",
        avatar_moose: "驼鹿",
        avatar_owl: "猫头鹰",
        irisName: "爱丽丝",
        irisGreetingFirst: "你好！我是爱丽丝。准备好训练眼睛了吗？",
        irisGreetingStreak: "欢迎回来！已连续{0}天！",
        irisGreetingReturn: "很高兴见到你！开始训练吧。",
        irisGreetingDone: "今天做得很好！让眼睛休息一下。",
        irisCompletionFirst: "你的眼睛感谢你！好的开始。",
        irisCompletionStreak: "第{0}天！继续保持！",
        irisCompletionMilestone: "太棒了！已完成{0}次训练！",
        irisCompletionNormal: "做得好！下次见。",
        irisDashboardEmpty: "开始你的第一次训练吧！",
        irisDashboardLow: "你正在积蓄力量。继续加油！",
        irisDashboardMedium: "好棒的一周！你的眼睛越来越强壮。",
        irisDashboardHigh: "连续{0}天！你太厉害了！",
        irisDashboardChampion: "真正的眼睛健身冠军！",
        irisChatTitle: "与Iris聊天",
        irisChatWelcome: "呼呼！我是Iris，你的眼睛健身猫头鹰！问我任何关于眼睛健康的问题，或者打个招呼！",
        irisChatLoading: "Iris正在醒来...",
        irisChatPlaceholder: "问Iris任何问题...",
        irisChatError: "呼...我的羽毛弄乱了！再试一次？",
        irisChatNoWebGPU: "Iris需要支持WebGPU的浏览器（Chrome 113+或Edge 113+）。请尝试更新浏览器！",
        irisChatLoadError: "呼...我没能正常醒来。",
        irisChatRetry: "重试",
        thisWeek: "本周",
        nextGoal: "下一个目标",
        badgesUnlocked: "已解锁 {0}/{1}",
        dontBreakStreak: "别断了你的连续记录！",
        greatJobToday: "今天干得好！",
        moreDaysStreak: "再坚持{0}天即可达成{1}天连续！",
        moreSessions: "再完成{0}次训练即可获得'{1}'！",
        morePoints: "再获得{0}积分即可达成'{1}'！",
        todayDone: "今日已完成",
        locked: "未解锁",
        sessions: "次训练",
        signIn: "登录",
        signOut: "退出",
        synced: "已同步",
        syncHint: "登录以在多设备间保存进度",
        nickname: "昵称",
        nicknamePlaceholder: "你的昵称",
        comingSoon: "云同步即将推出！",
    },
    pt: {
        leftRight: "Esquerda <-> Direita",
        beginIn: "Começa em",
        getReady: "Prepare-se",
        upAndDown: "Cima <-> Baixo",
        appName: "Eye Fitness",
        motto: "Porque olhos saudáveis não deveriam custar nada.",
        mottoTagline: "Treino de visão gratuito para um mundo mais saudável.",
        missionStatement: "O Eye Fitness é baseado numa crença simples: a saúde deve ser acessível a todos, não apenas a quem pode pagar. Sua visão é importante demais para ficar trancada atrás de assinaturas pagas. Por isso o Eye Fitness é, e sempre será, completamente gratuito. Sem versões de teste, sem recursos premium, sem custos ocultos — apenas exercícios eficazes para os olhos, disponíveis para qualquer pessoa com acesso à internet. Porque quando se trata de saúde, todos merecem acesso igual.",
        privacyPolicy: "Política de Privacidade",
        support: "Suporte do App",
        supportEmail: "Email: support@eyefitness.ca",
        privacyPolicyPersonal: "Coleta e Uso de Informações Pessoais",
        privacyPolicyPersonalText: "Não coletamos nem usamos informações pessoais.",
        privacyPolicyNonPersonal: "Coleta e Uso de Informações Não Pessoais",
        privacyPolicyNonPersonalText: "Coletamos dados anônimos de uso (como exercícios concluídos) para melhorar o aplicativo. Esses dados não estão vinculados à sua identidade.",
        disclaimer: "Aviso Legal: {0}",
        disclaimerTextPart1: "Consulte seu oftalmologista antes de iniciar os exercícios.\nLentes de contato não devem ser usadas antes, durante ou após os exercícios.\nAo continuar, você concorda em usar este site por sua própria conta e risco.",
        startExercise: "Escolha seu treino!",
        startExerciseDescription: "Iniciantes devem começar com o nível Fácil uma vez por dia durante uma semana. Depois, ajuste conforme se sentir.\nVocê pode pausar a qualquer momento clicando no botão de pausa ou pressionando 'espaço'.",
        easy: "Fácil",
        medium: "Médio",
        tough: "Difícil",
        intense: "Intenso",
        rest: "Descanso",
        blink: "Piscar",
        next: "Próximo",
        skipToNext: "Pular para o próximo exercício",
        finishedForToday: "Você terminou por hoje",
        circleRight: "Círculo Direita",
        circleLeft: "Círculo Esquerda",
        upLeft: "Cima Esquerda",
        upRight: "Cima Direita",
        downLeft: "Baixo Esquerda",
        downRight: "Baixo Direita",
        figure8Horizontal: "Oito Horizontal",
        figure8Vertical: "Oito Vertical",
        blinkExercise: "Exercício de Piscar",
        slowCircleLeft: "Círculo Lento Esquerda",
        eyeRollComplete: "Rotação Completa dos Olhos",
        squareClockwise: "Quadrado Horário",
        squareCounterClockwise: "Quadrado Anti-horário",
        trianglePattern: "Padrão Triângulo",
        starPattern: "Padrão Estrela",
        slowCircleRight: "Círculo Lento Direita",
        wavePattern: "Padrão Onda",
        groupBasics: "Básicos",
        groupBasicsDesc: "Níveis de dificuldade originais - perfeitos para começar",
        groupProgressive: "Progressivo",
        groupProgressiveDesc: "Treinos aprimorados com padrões de rastreamento avançados",
        progressiveEasy: "Progressivo Fácil",
        progressiveMedium: "Progressivo Médio",
        progressiveTough: "Progressivo Difícil",
        geometricPatterns: "Padrões Geométricos",
        selfTestTitle: "Teste de Visão",
        selfTestIntro: "Quão bem você enxerga? Leia as letras na tela e descubra! Os resultados são salvos para acompanhar seu progresso.",
        selfTestQuickStart: "Iniciar Teste de Visão",
        selfTestCalibrateFirst: "Calibrar Tela Primeiro",
        selfTestRecalibrate: "Recalibrar Tela",
        selfTestViewHistory: "Meus Resultados",
        selfTestCalibrationTitle: "Calibração da Tela",
        selfTestCalibrationDesc: "Coloque um cartão de crédito ou débito na tela. Arraste ou deslize até que o cartão na tela corresponda exatamente ao seu cartão real.",
        selfTestCreditCard: "CARTÃO DE CRÉDITO",
        selfTestConfirmCalibration: "Está Ótimo!",
        selfTestBack: "Voltar",
        selfTestDistanceDesc: "A que distância você está da tela?",
        selfTestEyeTitle: "Qual Olho?",
        selfTestEyeDesc: "Escolha qual olho testar. Cubra o outro olho gentilmente com a mão.",
        selfTestRightEye: "Olho Direito",
        selfTestLeftEye: "Olho Esquerdo",
        selfTestBothEyes: "Ambos os Olhos",
        selfTestEyeHint: "Dica: teste cada olho separadamente para melhores resultados.",
        selfTestDistanceReminder: "Mantenha esta distância:",
        selfTestCanYouRead: "Você consegue ler estas letras?",
        selfTestYes: "Sim",
        selfTestNo: "Não",
        selfTestResultsTitle: "Sua Pontuação",
        selfTestDecimal: "Decimal",
        selfTestAcuity_excellent: "Super Visão!",
        selfTestAcuity_normal: "Ótimo — Visão 20/20!",
        selfTestAcuity_near_normal: "Bom — Quase 20/20",
        selfTestAcuity_mild_impairment: "Regular — Pode Melhorar",
        selfTestAcuity_moderate: "Precisa de Atenção",
        selfTestAcuity_significant: "Consulte um Médico",
        selfTestResultsDisclaimer: "Isto é apenas uma estimativa, não um exame médico. Visite um oftalmologista para um exame adequado.",
        selfTestDisclaimerShort: "Não é um teste médico. Consulte seu oftalmologista para um exame real.",
        selfTestTestAnotherEye: "Testar Outro Olho",
        selfTestDone: "Pronto",
        selfTestHistoryTitle: "Meus Resultados",
        selfTestNoHistory: "Nenhum teste ainda! Faça seu primeiro teste de visão para começar a acompanhar.",
        selfTestDate: "Data",
        selfTestStartNew: "Novo Teste de Visão",
        selfTestLastResults: "Seus Últimos Resultados",
        selfTestTrendImproving: "Melhorando",
        selfTestTrendStable: "Estável",
        selfTestTrendDeclining: "Diminuindo",
        builtInQuebec: "Feito em Quebec 🍁",
        peopleDriven: "Feito para pessoas. Focado na comunidade. 100% Gratuito.",
        disclaimerCompact: "Não é conselho médico. Consulte seu oftalmologista antes de iniciar os exercícios.",
        sectionGames: "Jogos",
        sectionTraining: "Treino Ocular",
        sectionGamesDesc: "Treine seus olhos se divertindo",
        sectionTrainingDesc: "Rotinas de exercícios guiados",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "Quão rápidos são seus olhos?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Escale com seus olhos",
        dashboard: "Painel",
        progress: "Progresso",
        currentStreak: "Sequência Atual",
        longestStreak: "Maior Sequência",
        days: "dias",
        totalSessions: "Total de Sessões",
        completedDays: "Dias Concluídos",
        totalPoints: "Total de Pontos",
        points: "pontos",
        badges: "Medalhas",
        noBadges: "Complete exercícios para ganhar medalhas!",
        badge_first_session: "Primeiros Passos",
        badge_3_day_streak: "Sequência de 3 Dias",
        badge_7_day_streak: "Guerreiro Semanal",
        badge_14_day_streak: "Foco Quinzenal",
        badge_30_day_streak: "Mestre Mensal",
        badge_60_day_streak: "Disciplina de Diamante",
        badge_365_day_streak: "Ano da Visão",
        badge_10_sessions: "Dedicado",
        badge_25_sessions: "Quarto de Século",
        badge_50_sessions: "Campeão dos Olhos",
        badge_100_sessions: "Lenda da Visão",
        badge_200_sessions: "Bicentenário",
        badge_100_points: "Pontuação Centenária",
        badge_1000_points: "Mestre dos Pontos",
        badge_5000_points: "Pontuador de Elite",
        badge_explorer: "Explorador",
        badge_iron_eyes: "Olhos de Ferro",
        badge_pattern_pro: "Mestre dos Padrões",
        badge_level_up: "Subiu de Nível",
        badge_overachiever: "Superação",
        badge_hat_trick: "Hat Trick",
        badge_comeback_kid: "Retorno Triunfal",
        badge_weekend_warrior: "Guerreiro do Fim de Semana",
        badge_eye_curious: "Olhos Curiosos",
        badge_perfect_vision: "Clube 20/20",
        badge_progress_watcher: "Observador de Progresso",
        irisDashboardLegend: "Uma lenda viva do fitness ocular!",
        activityCalendar: "Calendário de Atividades",
        lastSession: "Última Sessão",
        startTraining: "Iniciar Treino",
        continueTraining: "Continuar Treino",
        today: "Hoje",
        lesActivity: "Menos",
        moreActivity: "Mais",
        lightMode: "Mudar para Modo Claro",
        darkMode: "Mudar para Modo Escuro",
        sepiaMode: "Mudar para Modo Sépia",
        audioOn: "Guia de Voz Ligado",
        audioOff: "Guia de Voz Desligado",
        lookLeft: "Olhe para a esquerda",
        lookRight: "Olhe para a direita",
        lookUp: "Olhe para cima",
        lookDown: "Olhe para baixo",
        lookCenter: "Centro",
        lookUpLeft: "Olhe para cima esquerda",
        lookUpRight: "Olhe para cima direita",
        lookDownLeft: "Olhe para baixo esquerda",
        lookDownRight: "Olhe para baixo direita",
        relaxEyes: "Relaxe",
        startTrainingCta: "Iniciar Treino de 5 Minutos",
        socialProofUsers: "10.000+ usuários no mundo",
        socialProofFree: "100% Gratuito para sempre",
        socialProofPrivacy: "Sem dados pessoais",
        featuresTitle: "Por que Eye Fitness?",
        featureFreeTitle: "100% Gratuito",
        featureFreeDesc: "Sem assinaturas, sem recursos premium, sem custos ocultos.",
        featurePrivacyTitle: "Privacidade em Primeiro",
        featurePrivacyDesc: "Não coletamos dados pessoais. Análises são anônimas.",
        featureUniversalTitle: "Funciona em Qualquer Lugar",
        featureUniversalDesc: "Use em qualquer dispositivo com navegador web.",
        featureScienceTitle: "Base Científica",
        featureScienceDesc: "Exercícios projetados para treino eficaz dos músculos oculares.",
        easyBenefit: "Perfeito para iniciantes. Movimentos suaves para reduzir o cansaço.",
        mediumBenefit: "Aumente a resistência com exercícios de intensidade moderada.",
        toughBenefit: "Desafie-se com treino ocular avançado.",
        intenseBenefit: "Intensidade máxima para praticantes experientes.",
        exerciseCount: "{0} exercícios",
        healthInfoTitle: "Informações Importantes de Saúde",
        avatarSelector: "Escolher Avatar",
        avatar_classic: "Olhos Clássicos",
        avatar_dog: "Cachorro",
        avatar_cat: "Gato",
        avatar_moose: "Alce",
        avatar_owl: "Coruja",
        irisName: "Iris",
        irisGreetingFirst: "Olá! Eu sou a Iris. Pronta para treinar seus olhos?",
        irisGreetingStreak: "Bem-vindo de volta! Sequência de {0} dias!",
        irisGreetingReturn: "Que bom te ver! Vamos treinar.",
        irisGreetingDone: "Ótimo trabalho hoje! Descanse os olhos.",
        irisCompletionFirst: "Seus olhos agradecem! Um ótimo começo.",
        irisCompletionStreak: "Dia {0}! Continue assim!",
        irisCompletionMilestone: "Incrível! {0} sessões concluídas!",
        irisCompletionNormal: "Muito bem! Até a próxima.",
        irisDashboardEmpty: "Comece seu primeiro treino!",
        irisDashboardLow: "Você está ganhando impulso. Continue!",
        irisDashboardMedium: "Que semana! Seus olhos estão ficando mais fortes.",
        irisDashboardHigh: "Sequência de {0} dias! Você está demais!",
        irisDashboardChampion: "Um verdadeiro campeão do fitness ocular!",
        irisChatTitle: "Conversar com Iris",
        irisChatWelcome: "Hoo-hoo! Sou Iris, sua coruja de fitness ocular! Pergunte sobre saúde dos olhos ou apenas diga oi!",
        irisChatLoading: "Iris está acordando...",
        irisChatPlaceholder: "Pergunte à Iris...",
        irisChatError: "Hoo... minhas penas se arrepiaram! Tentar de novo?",
        irisChatNoWebGPU: "Iris precisa de um navegador com suporte WebGPU (Chrome 113+ ou Edge 113+). Tente atualizar seu navegador!",
        irisChatLoadError: "Hoo... não consegui acordar direito.",
        irisChatRetry: "Tentar novamente",
        thisWeek: "Esta Semana",
        nextGoal: "Próxima Meta",
        badgesUnlocked: "{0} de {1} desbloqueadas",
        dontBreakStreak: "Não quebre sua sequência!",
        greatJobToday: "Bom trabalho hoje!",
        moreDaysStreak: "Mais {0} dias para uma sequência de {1} dias!",
        moreSessions: "Mais {0} sessões para ganhar '{1}'!",
        morePoints: "Mais {0} pontos para '{1}'!",
        todayDone: "Feito por hoje",
        locked: "Bloqueada",
        sessions: "sessões",
        signIn: "Entrar",
        signOut: "Sair",
        synced: "Sincronizado",
        syncHint: "Entre para manter seu progresso em todos os dispositivos",
        nickname: "Apelido",
        nicknamePlaceholder: "Seu apelido",
        comingSoon: "Sincronização na nuvem em breve!",
    },
    ru: {
        leftRight: "Лево <-> Право",
        beginIn: "Начало через",
        getReady: "Приготовтесь",
        upAndDown: "Верх <-> Низ",
        appName: "Фитнес для глаз",
        motto: "Потому что здоровые глаза не должны стоить денег.",
        mottoTagline: "Бесплатная тренировка зрения для здорового мира.",
        missionStatement: "Фитнес для глаз основан на простой вере: здоровье должно быть доступно всем, а не только тем, кто может себе это позволить. Ваше зрение слишком важно, чтобы быть заблокированным за платными подписками. Вот почему Фитнес для глаз был и всегда будет полностью бесплатным. Никаких пробных версий, никаких премиум-функций, никаких скрытых платежей — только эффективные упражнения для глаз, доступные каждому, у кого есть доступ в интернет. Потому что когда дело касается здоровья, каждый заслуживает равного доступа.",
        privacyPolicy: "Политика конфиденциальности",
        support: "Поддержка приложения",
        supportEmail: "Email: support@eyefitness.ca",
        privacyPolicyPersonal: "Сбор и использование личной информации",
        privacyPolicyPersonalText: "Мы не собираем и не используем личную информацию.",
        privacyPolicyNonPersonal: "Сбор и использование неличной информации",
        privacyPolicyNonPersonalText: "Мы собираем анонимные данные об использовании (например, завершенные упражнения) для улучшения приложения. Эти данные не связаны с вашей личностью.",
        disclaimer: "Заявления об отказе от ответственности: {0}",
        disclaimerTextPart1: "Пожалуйста проконсультируйтесь со своим доктором прежде чем начать упражнения." +
            " Нельзя одевать контактные линзы перед, во время и после упражнения." +
            " Начиная упражнения вы соглашаетесь использовать данный веб ресурс на свой собственный риск.",
        startExercise: "Выбери тренировку!",
        startExerciseDescription: "Для начинающих рекомендуется начать с Легкой степени сложности раз в день в течении недели." +
            " После этого смотреть по собственному самочувствию. Вы можете нажать на паузу в любое время исопльзуя для этого кнопку на экране или \"пробел\".",
        easy: "Легко",
        medium: "Средне",
        tough: "Сложно",
        intense: "Интенсив",
        rest: "Отдых",
        blink: "Поморгать",
        next: "Следующее",
        skipToNext: "Перейти к следующему упражнению",
        finishedForToday: "Вы закончили упражнения на сегодня",
        circleRight: "Вращение по часовой стрелке",
        circleLeft: "Вращение против часовой стрелки",
        upLeft: "Верх лево",
        upRight: "Верх право",
        downLeft: "Низ лево",
        downRight: "Низ право",
        // Phase 1: New exercises
        figure8Horizontal: "Восьмёрка Горизонтальная",
        figure8Vertical: "Восьмёрка Вертикальная",
        blinkExercise: "Упражнение Моргания",
        slowCircleLeft: "Медленное Вращение Влево",
        eyeRollComplete: "Полное Вращение Глаз",
        // Phase 2: Intermediate exercises
        squareClockwise: "Квадрат по Часовой Стрелке",
        squareCounterClockwise: "Квадрат Против Часовой Стрелки",
        trianglePattern: "Паттерн Треугольник",
        starPattern: "Паттерн Звезда",
        slowCircleRight: "Медленное Вращение Вправо",
        wavePattern: "Паттерн Волна",
        // Exercise groups
        groupBasics: "Базовые",
        groupBasicsDesc: "Оригинальные уровни сложности - идеально для начала",
        groupProgressive: "Прогрессивные",
        groupProgressiveDesc: "Улучшенные тренировки с продвинутыми паттернами слежения",
        progressiveEasy: "Прогрессивный Лёгкий",
        progressiveMedium: "Прогрессивный Средний",
        progressiveTough: "Прогрессивный Сложный",
        geometricPatterns: "Геометрические Паттерны",
        selfTestTitle: "Проверка Глаз",
        selfTestIntro: "Как хорошо ты видишь? Прочитай буквы на экране и узнай! Результаты сохраняются, чтобы ты мог следить за своим прогрессом.",
        selfTestQuickStart: "Начать Проверку",
        selfTestCalibrateFirst: "Сначала Настроить Экран",
        selfTestRecalibrate: "Перенастроить Экран",
        selfTestViewHistory: "Мои Результаты",
        selfTestCalibrationTitle: "Настройка Экрана",
        selfTestCalibrationDesc: "Приложи банковскую или кредитную карту к экрану. Двигай или перетаскивай, пока карта на экране не совпадёт с настоящей.",
        selfTestCreditCard: "КРЕДИТНАЯ КАРТА",
        selfTestConfirmCalibration: "Выглядит Отлично!",
        selfTestBack: "Назад",
        selfTestDistanceDesc: "Как далеко ты от экрана?",
        selfTestEyeTitle: "Какой Глаз?",
        selfTestEyeDesc: "Выбери, какой глаз проверить. Аккуратно прикрой другой глаз рукой.",
        selfTestRightEye: "Правый Глаз",
        selfTestLeftEye: "Левый Глаз",
        selfTestBothEyes: "Оба Глаза",
        selfTestEyeHint: "Совет: проверяй каждый глаз по отдельности для лучших результатов.",
        selfTestDistanceReminder: "Оставайся на этом расстоянии:",
        selfTestCanYouRead: "Можешь прочитать эти буквы?",
        selfTestYes: "Да",
        selfTestNo: "Нет",
        selfTestResultsTitle: "Твой Результат",
        selfTestDecimal: "Десятичная",
        selfTestAcuity_excellent: "Супер Зрение!",
        selfTestAcuity_normal: "Отлично — Зрение 20/20!",
        selfTestAcuity_near_normal: "Хорошо — Почти 20/20",
        selfTestAcuity_mild_impairment: "Неплохо — Можно Лучше",
        selfTestAcuity_moderate: "Нужно Внимание",
        selfTestAcuity_significant: "Сходи к Врачу",
        selfTestResultsDisclaimer: "Это только примерная оценка, а не осмотр у врача. Обратись к окулисту для настоящей проверки.",
        selfTestDisclaimerShort: "Это не медицинский тест. Посети окулиста для настоящей проверки.",
        selfTestTestAnotherEye: "Проверить Другой Глаз",
        selfTestDone: "Готово",
        selfTestHistoryTitle: "Мои Результаты",
        selfTestNoHistory: "Проверок ещё нет! Пройди первую проверку, чтобы начать отслеживать прогресс.",
        selfTestDate: "Дата",
        selfTestStartNew: "Новая Проверка",
        selfTestLastResults: "Твои Последние Результаты",
        selfTestTrendImproving: "Улучшается",
        selfTestTrendStable: "Стабильно",
        selfTestTrendDeclining: "Снижается",
        builtInQuebec: "Разработано в Квебеке 🍁",
        peopleDriven: "Ориентировано на людей. Ориентировано на сообщество. 100% бесплатно.",
        disclaimerCompact: "Не является медицинской рекомендацией. Проконсультируйтесь с офтальмологом перед началом упражнений.",
        sectionGames: "Игры",
        sectionTraining: "Тренировка Глаз",
        sectionGamesDesc: "Тренируйте глаза, играя",
        sectionTrainingDesc: "Программы упражнений с руководством",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "Насколько быстры ваши глаза?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Лазайте глазами",
        dashboard: "Панель управления",
        progress: "Прогресс",
        currentStreak: "Текущая серия",
        longestStreak: "Самая длинная серия",
        days: "дней",
        totalSessions: "Всего сессий",
        completedDays: "Завершенные дни",
        totalPoints: "Всего очков",
        points: "очков",
        badges: "Значки",
        noBadges: "Выполняйте упражнения, чтобы заработать значки!",
        badge_first_session: "Первые Шаги",
        badge_3_day_streak: "Серия 3 Дня",
        badge_7_day_streak: "Недельный Воин",
        badge_14_day_streak: "Двухнедельный Фокус",
        badge_30_day_streak: "Месячный Мастер",
        badge_60_day_streak: "Алмазная Дисциплина",
        badge_365_day_streak: "Год Зрения",
        badge_10_sessions: "Преданный",
        badge_25_sessions: "Четверть Века",
        badge_50_sessions: "Чемпион Глаз",
        badge_100_sessions: "Легенда Зрения",
        badge_200_sessions: "Двухсотый",
        badge_100_points: "Сто Очков",
        badge_1000_points: "Мастер Очков",
        badge_5000_points: "Элитный Игрок",
        badge_explorer: "Исследователь",
        badge_iron_eyes: "Железные Глаза",
        badge_pattern_pro: "Мастер Паттернов",
        badge_level_up: "Рост Уровня",
        badge_overachiever: "Перевыполнение",
        badge_hat_trick: "Хет-трик",
        badge_comeback_kid: "Триумфальное Возвращение",
        badge_weekend_warrior: "Воин Выходных",
        badge_eye_curious: "Любопытные Глаза",
        badge_perfect_vision: "Клуб 20/20",
        badge_progress_watcher: "Наблюдатель Прогресса",
        irisDashboardLegend: "Живая легенда фитнеса для глаз!",
        activityCalendar: "Календарь активности",
        lastSession: "Последняя сессия",
        startTraining: "Начать тренировку",
        continueTraining: "Продолжить тренировку",
        today: "Сегодня",
        lesActivity: "Меньше",
        moreActivity: "Больше",
        // Theme and audio
        lightMode: "Переключить на светлый режим",
        darkMode: "Переключить на тёмный режим",
        sepiaMode: "Переключить на режим сепия",
        audioOn: "Голосовое сопровождение включено",
        audioOff: "Голосовое сопровождение выключено",
        // Audio directions
        lookLeft: "Смотрите влево",
        lookRight: "Смотрите вправо",
        lookUp: "Смотрите вверх",
        lookDown: "Смотрите вниз",
        lookCenter: "Центр",
        lookUpLeft: "Смотрите вверх влево",
        lookUpRight: "Смотрите вверх вправо",
        lookDownLeft: "Смотрите вниз влево",
        lookDownRight: "Смотрите вниз вправо",
        relaxEyes: "Расслабьтесь",
        // Homepage redesign
        startTrainingCta: "Начать 5-минутную тренировку",
        socialProofUsers: "10 000+ пользователей по всему миру",
        socialProofFree: "100% Бесплатно навсегда",
        socialProofPrivacy: "Без личных данных",
        // Features section
        featuresTitle: "Почему Фитнес для глаз?",
        featureFreeTitle: "100% Бесплатно",
        featureFreeDesc: "Без подписок, без премиум-функций, без скрытых платежей.",
        featurePrivacyTitle: "Конфиденциальность прежде всего",
        featurePrivacyDesc: "Мы не собираем личные данные. Аналитика анонимна.",
        featureUniversalTitle: "Работает везде",
        featureUniversalDesc: "Используйте на любом устройстве с веб-браузером.",
        featureScienceTitle: "Научный подход",
        featureScienceDesc: "Упражнения для эффективной тренировки глазных мышц.",
        // Enhanced exercise descriptions
        easyBenefit: "Идеально для начинающих. Мягкие движения для снятия напряжения.",
        mediumBenefit: "Развивайте выносливость упражнениями средней интенсивности.",
        toughBenefit: "Бросьте себе вызов продвинутой тренировкой глаз.",
        intenseBenefit: "Максимальная интенсивность для опытных практикующих.",
        exerciseCount: "{0} упражнений",
        healthInfoTitle: "Важная информация о здоровье",
        // Avatar selector
        avatarSelector: "Выбрать Аватар",
        avatar_classic: "Классические Глаза",
        avatar_dog: "Собака",
        avatar_cat: "Кот",
        avatar_moose: "Лось",
        avatar_owl: "Сова",
        // IRIS mascot
        irisName: "Ирис",
        irisGreetingFirst: "Привет! Я Ирис. Готовы тренировать глаза?",
        irisGreetingStreak: "С возвращением! Серия {0} дней!",
        irisGreetingReturn: "Рады вас видеть! Начнём тренировку.",
        irisGreetingDone: "Отличная работа сегодня! Дайте глазам отдохнуть.",
        irisCompletionFirst: "Ваши глаза благодарны! Отличное начало.",
        irisCompletionStreak: "День {0}! Продолжайте в том же духе!",
        irisCompletionMilestone: "Невероятно! {0} сессий завершено!",
        irisCompletionNormal: "Отлично! До следующего раза.",
        irisDashboardEmpty: "Начните первую тренировку!",
        irisDashboardLow: "Набираете обороты. Продолжайте!",
        irisDashboardMedium: "Какая неделя! Ваши глаза крепнут.",
        irisDashboardHigh: "Серия {0} дней! Вы в ударе!",
        irisDashboardChampion: "Настоящий чемпион фитнеса для глаз!",
        irisChatTitle: "Чат с Iris",
        irisChatWelcome: "Угу-угу! Я Iris, ваша сова фитнеса для глаз! Спросите меня о здоровье глаз или просто скажите привет!",
        irisChatLoading: "Iris просыпается...",
        irisChatPlaceholder: "Спросите Iris...",
        irisChatError: "Угу... мои перья взъерошились! Попробуем снова?",
        irisChatNoWebGPU: "Iris нужен браузер с поддержкой WebGPU (Chrome 113+ или Edge 113+). Попробуйте обновить браузер!",
        irisChatLoadError: "Угу... не удалось проснуться как следует.",
        irisChatRetry: "Попробовать снова",
        thisWeek: "Эта неделя",
        nextGoal: "Следующая цель",
        badgesUnlocked: "{0} из {1} разблокировано",
        dontBreakStreak: "Не прерывайте серию!",
        greatJobToday: "Отличная работа сегодня!",
        moreDaysStreak: "Ещё {0} дней до серии в {1} дней!",
        moreSessions: "Ещё {0} сессий до '{1}'!",
        morePoints: "Ещё {0} очков до '{1}'!",
        todayDone: "На сегодня выполнено",
        locked: "Заблокировано",
        sessions: "сессий",
        signIn: "Войти",
        signOut: "Выйти",
        synced: "Синхронизировано",
        syncHint: "Войдите, чтобы сохранить прогресс на всех устройствах",
        nickname: "Имя",
        nicknamePlaceholder: "Ваше имя",
        comingSoon: "Облачная синхронизация скоро!",
    },
    uk: {
        leftRight: "Ліво <-> Право",
        beginIn: "Почати через",
        getReady: "Приготуйтеся",
        upAndDown: "Вгору <-> Вниз",
        appName: "Фітнес для очей",
        motto: "Тому що здорові очі не повинні коштувати грошей.",
        mottoTagline: "Безкоштовне тренування зору для здорового світу.",
        missionStatement: "Фітнес для очей побудований на простій вірі: здоров'я має бути доступним для всіх, а не лише для тих, хто може собі це дозволити. Ваш зір занадто важливий, щоб бути заблокованим за платними підписками. Ось чому Фітнес для очей був і завжди буде повністю безкоштовним. Ніяких пробних версій, ніяких преміум-функцій, ніяких прихованих витрат — лише ефективні вправи для очей, доступні кожному, хто має доступ до інтернету. Тому що коли справа стосується здоров'я, кожен заслуговує на рівний доступ.",
        privacyPolicy: "Політика конфіденційності",
        support: "Підтримка додатку",
        supportEmail: "Email: support@eyefitness.ca",
        privacyPolicyPersonal: "Збір та використання особистої інформації",
        privacyPolicyPersonalText: "Ми не збираємо і не використовуємо особисту інформацію.",
        privacyPolicyNonPersonal: "Збір та використання неособистої інформації",
        privacyPolicyNonPersonalText: "Ми збираємо анонімні дані про використання (наприклад, завершені вправи) для покращення додатку. Ці дані не пов'язані з вашою особою.",
        disclaimer: "Заява про відмову від відповідальності: {0}",
        disclaimerTextPart1: "Будь ласка, проконсультуйтеся зі своїм офтальмологом перед початком вправ.\n" +
            " Контактні лінзи не можна носити до, під час та після виконання вправ.\n" +
            " Продовжуючи, ви погоджуєтеся використовувати цей веб-сайт на власний ризик.",
        startExercise: "Обери тренування!",
        startExerciseDescription: "Початківцям слід почати з рівня Легко один раз на день протягом тижня. Потім регулюйте згідно з вашим самопочуттям.\n" +
            " Ви можете зробити паузу в будь-який момент, натиснувши кнопку паузи або клавішу 'пробіл'.",
        easy: "Легко",
        medium: "Середньо",
        tough: "Важко",
        intense: "Інтенсив",
        rest: "Відпочинок",
        blink: "Моргнути",
        next: "Далі",
        skipToNext: "Перейти до наступної вправи",
        finishedForToday: "Ви закінчили на сьогодні",
        circleRight: "Коло за годинниковою стрілкою",
        circleLeft: "Коло проти годинникової стрілки",
        upLeft: "Вгору ліво",
        upRight: "Вгору право",
        downLeft: "Вниз ліво",
        downRight: "Вниз право",
        // Phase 1: New exercises
        figure8Horizontal: "Вісімка Горизонтальна",
        figure8Vertical: "Вісімка Вертикальна",
        blinkExercise: "Вправа Моргання",
        slowCircleLeft: "Повільне Обертання Вліво",
        eyeRollComplete: "Повне Обертання Очей",
        // Phase 2: Intermediate exercises
        squareClockwise: "Квадрат за Годинниковою Стрілкою",
        squareCounterClockwise: "Квадрат Проти Годинникової Стрілки",
        trianglePattern: "Патерн Трикутник",
        starPattern: "Патерн Зірка",
        slowCircleRight: "Повільне Обертання Вправо",
        wavePattern: "Патерн Хвиля",
        // Exercise groups
        groupBasics: "Базові",
        groupBasicsDesc: "Оригінальні рівні складності - ідеально для початку",
        groupProgressive: "Прогресивні",
        groupProgressiveDesc: "Покращені тренування з просунутими патернами відстеження",
        progressiveEasy: "Прогресивний Легкий",
        progressiveMedium: "Прогресивний Середній",
        progressiveTough: "Прогресивний Важкий",
        geometricPatterns: "Геометричні Патерни",
        selfTestTitle: "Перевірка Очей",
        selfTestIntro: "Як добре ти бачиш? Прочитай літери на екрані та дізнайся! Результати зберігаються, щоб ти міг стежити за своїм прогресом.",
        selfTestQuickStart: "Почати Перевірку",
        selfTestCalibrateFirst: "Спочатку Налаштувати Екран",
        selfTestRecalibrate: "Переналаштувати Екран",
        selfTestViewHistory: "Мої Результати",
        selfTestCalibrationTitle: "Налаштування Екрана",
        selfTestCalibrationDesc: "Приклади банківську або кредитну картку до екрана. Рухай або перетягуй, доки картка на екрані не співпаде з справжньою.",
        selfTestCreditCard: "КРЕДИТНА КАРТКА",
        selfTestConfirmCalibration: "Виглядає Чудово!",
        selfTestBack: "Назад",
        selfTestDistanceDesc: "Як далеко ти від екрана?",
        selfTestEyeTitle: "Яке Око?",
        selfTestEyeDesc: "Обери, яке око перевірити. Обережно прикрий інше око рукою.",
        selfTestRightEye: "Праве Око",
        selfTestLeftEye: "Ліве Око",
        selfTestBothEyes: "Обидва Ока",
        selfTestEyeHint: "Порада: перевіряй кожне око окремо для кращих результатів.",
        selfTestDistanceReminder: "Залишайся на цій відстані:",
        selfTestCanYouRead: "Можеш прочитати ці літери?",
        selfTestYes: "Так",
        selfTestNo: "Ні",
        selfTestResultsTitle: "Твій Результат",
        selfTestDecimal: "Десяткова",
        selfTestAcuity_excellent: "Супер Зір!",
        selfTestAcuity_normal: "Чудово — Зір 20/20!",
        selfTestAcuity_near_normal: "Добре — Майже 20/20",
        selfTestAcuity_mild_impairment: "Непогано — Можна Краще",
        selfTestAcuity_moderate: "Потребує Уваги",
        selfTestAcuity_significant: "Сходи до Лікаря",
        selfTestResultsDisclaimer: "Це лише приблизна оцінка, а не огляд у лікаря. Зверніться до окуліста для справжньої перевірки.",
        selfTestDisclaimerShort: "Це не медичний тест. Відвідай окуліста для справжньої перевірки.",
        selfTestTestAnotherEye: "Перевірити Інше Око",
        selfTestDone: "Готово",
        selfTestHistoryTitle: "Мої Результати",
        selfTestNoHistory: "Перевірок ще немає! Пройди першу перевірку, щоб почати стежити за прогресом.",
        selfTestDate: "Дата",
        selfTestStartNew: "Нова Перевірка",
        selfTestLastResults: "Твої Останні Результати",
        selfTestTrendImproving: "Покращується",
        selfTestTrendStable: "Стабільно",
        selfTestTrendDeclining: "Знижується",
        builtInQuebec: "Розроблено в Квебеку 🍁",
        peopleDriven: "Орієнтовано на людей. Орієнтовано на спільноту. 100% безкоштовно.",
        disclaimerCompact: "Не є медичною порадою. Проконсультуйтеся з офтальмологом перед початком вправ.",
        sectionGames: "Ігри",
        sectionTraining: "Тренування Очей",
        sectionGamesDesc: "Тренуйте очі, граючи",
        sectionTrainingDesc: "Програми вправ з керівництвом",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "Наскільки швидкі ваші очі?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Лазьте очима",
        dashboard: "Панель управління",
        progress: "Прогрес",
        currentStreak: "Поточна серія",
        longestStreak: "Найдовша серія",
        days: "днів",
        totalSessions: "Всього сесій",
        completedDays: "Завершені дні",
        totalPoints: "Всього балів",
        points: "балів",
        badges: "Значки",
        noBadges: "Виконуйте вправи, щоб заробити значки!",
        badge_first_session: "Перші Кроки",
        badge_3_day_streak: "Серія 3 Дні",
        badge_7_day_streak: "Тижневий Воїн",
        badge_14_day_streak: "Двотижневий Фокус",
        badge_30_day_streak: "Місячний Майстер",
        badge_60_day_streak: "Діамантова Дисципліна",
        badge_365_day_streak: "Рік Зору",
        badge_10_sessions: "Відданий",
        badge_25_sessions: "Чверть Століття",
        badge_50_sessions: "Чемпіон Очей",
        badge_100_sessions: "Легенда Зору",
        badge_200_sessions: "Двохсотий",
        badge_100_points: "Сто Балів",
        badge_1000_points: "Майстер Балів",
        badge_5000_points: "Елітний Гравець",
        badge_explorer: "Дослідник",
        badge_iron_eyes: "Залізні Очі",
        badge_pattern_pro: "Майстер Патернів",
        badge_level_up: "Підвищення Рівня",
        badge_overachiever: "Перевиконання",
        badge_hat_trick: "Хет-трік",
        badge_comeback_kid: "Тріумфальне Повернення",
        badge_weekend_warrior: "Воїн Вихідних",
        badge_eye_curious: "Допитливі Очі",
        badge_perfect_vision: "Клуб 20/20",
        badge_progress_watcher: "Спостерігач Прогресу",
        irisDashboardLegend: "Жива легенда фітнесу для очей!",
        activityCalendar: "Календар активності",
        lastSession: "Остання сесія",
        startTraining: "Почати тренування",
        continueTraining: "Продовжити тренування",
        today: "Сьогодні",
        lesActivity: "Менше",
        moreActivity: "Більше",
        // Theme and audio
        lightMode: "Перемкнути на світлий режим",
        darkMode: "Перемкнути на темний режим",
        sepiaMode: "Перемкнути на режим сепія",
        audioOn: "Голосовий супровід увімкнено",
        audioOff: "Голосовий супровід вимкнено",
        // Audio directions
        lookLeft: "Дивіться вліво",
        lookRight: "Дивіться вправо",
        lookUp: "Дивіться вгору",
        lookDown: "Дивіться вниз",
        lookCenter: "Центр",
        lookUpLeft: "Дивіться вгору вліво",
        lookUpRight: "Дивіться вгору вправо",
        lookDownLeft: "Дивіться вниз вліво",
        lookDownRight: "Дивіться вниз вправо",
        relaxEyes: "Розслабтеся",
        // Homepage redesign
        startTrainingCta: "Розпочати 5-хвилинне тренування",
        socialProofUsers: "10,000+ користувачів по всьому світу",
        socialProofFree: "100% Безкоштовно назавжди",
        socialProofPrivacy: "Без особистих даних",
        // Features section
        featuresTitle: "Чому Фітнес для очей?",
        featureFreeTitle: "100% Безкоштовно",
        featureFreeDesc: "Без підписок, без преміум-функцій, без прихованих витрат.",
        featurePrivacyTitle: "Конфіденційність перш за все",
        featurePrivacyDesc: "Ми не збираємо особисті дані. Аналітика анонімна.",
        featureUniversalTitle: "Працює скрізь",
        featureUniversalDesc: "Використовуйте на будь-якому пристрої з веб-браузером.",
        featureScienceTitle: "Науковий підхід",
        featureScienceDesc: "Вправи для ефективного тренування очних м'язів.",
        // Enhanced exercise descriptions
        easyBenefit: "Ідеально для початківців. М'які рухи для зняття напруги.",
        mediumBenefit: "Розвивайте витривалість вправами середньої інтенсивності.",
        toughBenefit: "Киньте собі виклик просунутим тренуванням очей.",
        intenseBenefit: "Максимальна інтенсивність для досвідчених практикуючих.",
        exerciseCount: "{0} вправ",
        healthInfoTitle: "Важлива інформація про здоров'я",
        // Avatar selector
        avatarSelector: "Обрати Аватар",
        avatar_classic: "Класичні Очі",
        avatar_dog: "Собака",
        avatar_cat: "Кіт",
        avatar_moose: "Лось",
        avatar_owl: "Сова",
        // IRIS mascot
        irisName: "Ірис",
        irisGreetingFirst: "Привіт! Я Ірис. Готові тренувати очі?",
        irisGreetingStreak: "З поверненням! Серія {0} днів!",
        irisGreetingReturn: "Раді вас бачити! Починаємо тренування.",
        irisGreetingDone: "Чудова робота сьогодні! Дайте очам відпочити.",
        irisCompletionFirst: "Ваші очі вдячні! Чудовий початок.",
        irisCompletionStreak: "День {0}! Тримайте темп!",
        irisCompletionMilestone: "Неймовірно! {0} сесій завершено!",
        irisCompletionNormal: "Чудово! До наступного разу.",
        irisDashboardEmpty: "Почніть перше тренування!",
        irisDashboardLow: "Набираєте обертів. Продовжуйте!",
        irisDashboardMedium: "Який тиждень! Ваші очі міцніють.",
        irisDashboardHigh: "Серія {0} днів! Ви у вогні!",
        irisDashboardChampion: "Справжній чемпіон фітнесу для очей!",
        irisChatTitle: "Чат з Iris",
        irisChatWelcome: "Угу-угу! Я Iris, ваша сова фітнесу для очей! Запитайте мене про здоров'я очей або просто привітайтеся!",
        irisChatLoading: "Iris прокидається...",
        irisChatPlaceholder: "Запитайте Iris...",
        irisChatError: "Угу... моє пір'я скуйовджилось! Спробуємо ще раз?",
        irisChatNoWebGPU: "Iris потребує браузер з підтримкою WebGPU (Chrome 113+ або Edge 113+). Спробуйте оновити браузер!",
        irisChatLoadError: "Угу... не вдалося прокинутися як слід.",
        irisChatRetry: "Спробувати ще",
        thisWeek: "Цей тиждень",
        nextGoal: "Наступна ціль",
        badgesUnlocked: "{0} з {1} розблоковано",
        dontBreakStreak: "Не переривайте серію!",
        greatJobToday: "Чудова робота сьогодні!",
        moreDaysStreak: "Ще {0} днів до серії у {1} днів!",
        moreSessions: "Ще {0} сесій до '{1}'!",
        morePoints: "Ще {0} балів до '{1}'!",
        todayDone: "На сьогодні виконано",
        locked: "Заблоковано",
        sessions: "сесій",
        signIn: "Увійти",
        signOut: "Вийти",
        synced: "Синхронізовано",
        syncHint: "Увійдіть, щоб зберегти прогрес на всіх пристроях",
        nickname: "Ім'я",
        nicknamePlaceholder: "Ваше ім'я",
        comingSoon: "Хмарна синхронізація скоро!",
    },
    de: {
        leftRight: "Links <-> Rechts",
        beginIn: "Beginnt in",
        getReady: "Mach dich bereit",
        upAndDown: "Oben <-> Unten",
        appName: "Augen Fitness",
        motto: "Weil gesunde Augen nichts kosten sollten.",
        mottoTagline: "Kostenloses Sehtraining für eine gesündere Welt.",
        missionStatement: "Augen Fitness basiert auf einem einfachen Glauben: Gesundheit sollte für alle zugänglich sein, nicht nur für diejenigen, die es sich leisten können. Ihre Sehkraft ist zu wichtig, um hinter Bezahlschranken und Abonnements versteckt zu sein. Deshalb ist Augen Fitness und wird immer völlig kostenlos sein. Keine Testversionen, keine Premium-Funktionen, keine versteckten Kosten – nur effektive Augenübungen, die jedem mit Internetzugang zur Verfügung stehen. Denn wenn es um Gesundheit geht, verdient jeder gleichen Zugang.",
        privacyPolicy: "Datenschutzrichtlinie",
        support: "App-Support",
        supportEmail: "E-Mail: dev.samsklepal@gmail.com",
        privacyPolicyPersonal: "Erhebung und Verwendung personenbezogener Daten",
        privacyPolicyPersonalText: "Wir erheben und verwenden keine personenbezogenen Daten.",
        privacyPolicyNonPersonal: "Erhebung und Verwendung nicht personenbezogener Daten",
        privacyPolicyNonPersonalText: "Wir erfassen anonyme Nutzungsdaten (z. B. abgeschlossene Übungen), um die Anwendung zu verbessern. Diese Daten sind nicht mit Ihrer Identität verknüpft.",
        disclaimer: "Haftungsausschluss: {0}",
        disclaimerTextPart1: "Bitte konsultieren Sie zuerst Ihren Augenarzt, bevor Sie mit den Übungen beginnen.\n" +
            " Kontaktlinsen dürfen vor, während und nach den Übungen nicht getragen werden.\n" +
            " Mit der Fortsetzung erklären Sie sich einverstanden, diese Website auf eigene Gefahr zu nutzen.",
        startExercise: "Wähle dein Training!",
        startExerciseDescription: "Anfänger sollten eine Woche lang einmal täglich mit dem leichten Level beginnen. Danach nach Gefühl anpassen.\n" +
            " Sie können jederzeit pausieren, indem Sie auf die Pause-Schaltfläche klicken oder 'Leertaste' drücken.",
        easy: "Leicht",
        medium: "Mittel",
        tough: "Schwer",
        intense: "Intensiv",
        rest: "Pause",
        blink: "Blinzeln",
        next: "Nächste",
        skipToNext: "Zur nächsten Übung springen",
        finishedForToday: "Sie sind für heute fertig",
        circleRight: "Kreis rechts",
        circleLeft: "Kreis links",
        upLeft: "Oben links",
        upRight: "Oben rechts",
        downLeft: "Unten links",
        downRight: "Unten rechts",
        // Phase 1: New exercises
        figure8Horizontal: "Achter Horizontal",
        figure8Vertical: "Achter Vertikal",
        blinkExercise: "Blinzelübung",
        slowCircleLeft: "Langsamer Kreis Links",
        eyeRollComplete: "Vollständige Augenrotation",
        // Phase 2: Intermediate exercises
        squareClockwise: "Quadrat Im Uhrzeigersinn",
        squareCounterClockwise: "Quadrat Gegen den Uhrzeigersinn",
        trianglePattern: "Dreiecksmuster",
        starPattern: "Sternmuster",
        slowCircleRight: "Langsamer Kreis Rechts",
        wavePattern: "Wellenmuster",
        // Exercise groups
        groupBasics: "Grundlagen",
        groupBasicsDesc: "Original-Schwierigkeitsstufen - perfekt für den Einstieg",
        groupProgressive: "Progressiv",
        groupProgressiveDesc: "Verbesserte Workouts mit fortgeschrittenen Verfolgungsmustern",
        progressiveEasy: "Progressiv Leicht",
        progressiveMedium: "Progressiv Mittel",
        progressiveTough: "Progressiv Schwer",
        geometricPatterns: "Geometrische Muster",
        selfTestTitle: "Augen-Check",
        selfTestIntro: "Wie gut siehst du? Lies die Buchstaben auf dem Bildschirm und finde es heraus! Ergebnisse werden gespeichert, damit du deinen Fortschritt verfolgen kannst.",
        selfTestQuickStart: "Augen-Check Starten",
        selfTestCalibrateFirst: "Zuerst Bildschirm Kalibrieren",
        selfTestRecalibrate: "Bildschirm Neu Kalibrieren",
        selfTestViewHistory: "Meine Ergebnisse",
        selfTestCalibrationTitle: "Bildschirmkalibrierung",
        selfTestCalibrationDesc: "Lege eine Kredit- oder Bankkarte flach an deinen Bildschirm. Ziehe oder schiebe, bis die Karte auf dem Bildschirm genau so groß ist wie deine echte Karte.",
        selfTestCreditCard: "KREDITKARTE",
        selfTestConfirmCalibration: "Sieht Gut Aus!",
        selfTestBack: "Zurück",
        selfTestDistanceDesc: "Wie weit bist du vom Bildschirm entfernt?",
        selfTestEyeTitle: "Welches Auge?",
        selfTestEyeDesc: "Wähle, welches Auge du testen möchtest. Decke das andere Auge sanft mit der Hand ab.",
        selfTestRightEye: "Rechtes Auge",
        selfTestLeftEye: "Linkes Auge",
        selfTestBothEyes: "Beide Augen",
        selfTestEyeHint: "Tipp: Teste jedes Auge einzeln für die besten Ergebnisse.",
        selfTestDistanceReminder: "Bleib in diesem Abstand:",
        selfTestCanYouRead: "Kannst du diese Buchstaben lesen?",
        selfTestYes: "Ja",
        selfTestNo: "Nein",
        selfTestResultsTitle: "Dein Ergebnis",
        selfTestDecimal: "Dezimal",
        selfTestAcuity_excellent: "Super Sehkraft!",
        selfTestAcuity_normal: "Toll — 20/20 Sehkraft!",
        selfTestAcuity_near_normal: "Gut — Fast 20/20",
        selfTestAcuity_mild_impairment: "Okay — Geht Noch Besser",
        selfTestAcuity_moderate: "Braucht Aufmerksamkeit",
        selfTestAcuity_significant: "Geh zum Arzt",
        selfTestResultsDisclaimer: "Das ist nur eine Schätzung, keine ärztliche Untersuchung. Geh zum Augenarzt für eine richtige Untersuchung.",
        selfTestDisclaimerShort: "Kein medizinischer Test. Geh zum Augenarzt für eine echte Untersuchung.",
        selfTestTestAnotherEye: "Anderes Auge Testen",
        selfTestDone: "Fertig",
        selfTestHistoryTitle: "Meine Ergebnisse",
        selfTestNoHistory: "Noch keine Tests! Mach deinen ersten Augen-Check, um deinen Fortschritt zu verfolgen.",
        selfTestDate: "Datum",
        selfTestStartNew: "Neuer Augen-Check",
        selfTestLastResults: "Deine Letzten Ergebnisse",
        selfTestTrendImproving: "Verbessert sich",
        selfTestTrendStable: "Stabil",
        selfTestTrendDeclining: "Verschlechtert sich",
        builtInQuebec: "Entwickelt in Quebec 🍁",
        peopleDriven: "Menschenorientiert. Gemeinschaftsfokussiert. 100% Kostenlos.",
        disclaimerCompact: "Kein medizinischer Rat. Konsultieren Sie Ihren Augenarzt, bevor Sie mit den Übungen beginnen.",
        sectionGames: "Spiele",
        sectionTraining: "Augentraining",
        sectionGamesDesc: "Trainiere deine Augen spielerisch",
        sectionTrainingDesc: "Geführte Übungsprogramme",
        focusCatcher: "Focus Catcher",
        focusCatcherDesc: "Wie schnell sind deine Augen?",
        rockClimber: "Rock Climber",
        rockClimberDesc: "Klettern mit den Augen",
        dashboard: "Dashboard",
        progress: "Fortschritt",
        currentStreak: "Aktuelle Serie",
        longestStreak: "Längste Serie",
        days: "Tage",
        totalSessions: "Gesamte Sitzungen",
        completedDays: "Abgeschlossene Tage",
        totalPoints: "Gesamtpunkte",
        points: "Punkte",
        badges: "Abzeichen",
        noBadges: "Absolvieren Sie Übungen, um Abzeichen zu verdienen!",
        badge_first_session: "Erste Schritte",
        badge_3_day_streak: "3-Tage-Serie",
        badge_7_day_streak: "Wochenkrieger",
        badge_14_day_streak: "Zwei-Wochen-Fokus",
        badge_30_day_streak: "Monatsmeister",
        badge_60_day_streak: "Diamant-Disziplin",
        badge_365_day_streak: "Jahr der Sehkraft",
        badge_10_sessions: "Engagiert",
        badge_25_sessions: "Vierteljahrhundert",
        badge_50_sessions: "Augen-Champion",
        badge_100_sessions: "Seh-Legende",
        badge_200_sessions: "Zweihundertster",
        badge_100_points: "Jahrhundert-Punktzahl",
        badge_1000_points: "Punkte-Meister",
        badge_5000_points: "Elite-Scorer",
        badge_explorer: "Entdecker",
        badge_iron_eyes: "Eiserne Augen",
        badge_pattern_pro: "Muster-Profi",
        badge_level_up: "Aufgestiegen",
        badge_overachiever: "Übererfüller",
        badge_hat_trick: "Hattrick",
        badge_comeback_kid: "Comeback-Kind",
        badge_weekend_warrior: "Wochenend-Krieger",
        badge_eye_curious: "Neugierige Augen",
        badge_perfect_vision: "20/20-Club",
        badge_progress_watcher: "Fortschritts-Beobachter",
        irisDashboardLegend: "Eine lebende Legende des Augen-Fitness!",
        activityCalendar: "Aktivitätskalender",
        lastSession: "Letzte Sitzung",
        startTraining: "Training starten",
        continueTraining: "Training fortsetzen",
        today: "Heute",
        lesActivity: "Weniger",
        moreActivity: "Mehr",
        // Theme and audio
        lightMode: "Zum hellen Modus wechseln",
        darkMode: "Zum dunklen Modus wechseln",
        sepiaMode: "Zum Sepia-Modus wechseln",
        audioOn: "Sprachführung Ein",
        audioOff: "Sprachführung Aus",
        // Audio directions
        lookLeft: "Schauen Sie nach links",
        lookRight: "Schauen Sie nach rechts",
        lookUp: "Schauen Sie nach oben",
        lookDown: "Schauen Sie nach unten",
        lookCenter: "Mitte",
        lookUpLeft: "Schauen Sie nach oben links",
        lookUpRight: "Schauen Sie nach oben rechts",
        lookDownLeft: "Schauen Sie nach unten links",
        lookDownRight: "Schauen Sie nach unten rechts",
        relaxEyes: "Entspannen",
        // Homepage redesign
        startTrainingCta: "5-Minuten Training starten",
        socialProofUsers: "10.000+ Nutzer weltweit",
        socialProofFree: "100% Kostenlos für immer",
        socialProofPrivacy: "Keine personenbezogenen Daten",
        // Features section
        featuresTitle: "Warum Augen Fitness?",
        featureFreeTitle: "100% Kostenlos",
        featureFreeDesc: "Keine Abonnements, keine Premium-Funktionen, keine versteckten Kosten.",
        featurePrivacyTitle: "Datenschutz zuerst",
        featurePrivacyDesc: "Wir sammeln keine persönlichen Daten. Analysen sind anonym.",
        featureUniversalTitle: "Funktioniert überall",
        featureUniversalDesc: "Nutzen Sie es auf jedem Gerät mit Webbrowser.",
        featureScienceTitle: "Wissenschaftlich fundiert",
        featureScienceDesc: "Übungen für effektives Augenmuskeltraining.",
        // Enhanced exercise descriptions
        easyBenefit: "Perfekt für Anfänger. Sanfte Bewegungen zur Reduzierung der Belastung.",
        mediumBenefit: "Bauen Sie Ausdauer mit Übungen mittlerer Intensität auf.",
        toughBenefit: "Fordern Sie sich mit fortgeschrittenem Augentraining heraus.",
        intenseBenefit: "Maximale Intensität für erfahrene Anwender.",
        exerciseCount: "{0} Übungen",
        healthInfoTitle: "Wichtige Gesundheitsinformationen",
        // Avatar selector
        avatarSelector: "Avatar wählen",
        avatar_classic: "Klassische Augen",
        avatar_dog: "Hund",
        avatar_cat: "Katze",
        avatar_moose: "Elch",
        avatar_owl: "Eule",
        // IRIS mascot
        irisName: "Iris",
        irisGreetingFirst: "Hallo! Ich bin Iris. Bereit für das Augentraining?",
        irisGreetingStreak: "Willkommen zurück! {0}-Tage-Serie!",
        irisGreetingReturn: "Schön, Sie zu sehen! Los geht's.",
        irisGreetingDone: "Tolle Arbeit heute! Gönnen Sie Ihren Augen Ruhe.",
        irisCompletionFirst: "Ihre Augen danken es Ihnen! Ein toller Start.",
        irisCompletionStreak: "Tag {0}! Weiter so!",
        irisCompletionMilestone: "Unglaublich! {0} Sitzungen abgeschlossen!",
        irisCompletionNormal: "Gut gemacht! Bis zum nächsten Mal.",
        irisDashboardEmpty: "Starten Sie Ihr erstes Training!",
        irisDashboardLow: "Sie bauen Schwung auf. Weiter so!",
        irisDashboardMedium: "Was für eine Woche! Ihre Augen werden stärker.",
        irisDashboardHigh: "{0}-Tage-Serie! Sie sind in Topform!",
        irisDashboardChampion: "Ein wahrer Augen-Fitness-Champion!",
        irisChatTitle: "Mit Iris chatten",
        irisChatWelcome: "Huu-huu! Ich bin Iris, deine Augen-Fitness-Eule! Frag mich alles über Augengesundheit oder sag einfach Hallo!",
        irisChatLoading: "Iris wacht auf...",
        irisChatPlaceholder: "Frag Iris etwas...",
        irisChatError: "Huu... meine Federn sind durcheinander! Nochmal versuchen?",
        irisChatNoWebGPU: "Iris braucht einen Browser mit WebGPU-Unterstützung (Chrome 113+ oder Edge 113+). Versuche deinen Browser zu aktualisieren!",
        irisChatLoadError: "Huu... ich konnte nicht richtig aufwachen.",
        irisChatRetry: "Erneut versuchen",
        thisWeek: "Diese Woche",
        nextGoal: "Nächstes Ziel",
        badgesUnlocked: "{0} von {1} freigeschaltet",
        dontBreakStreak: "Unterbrechen Sie Ihre Serie nicht!",
        greatJobToday: "Tolle Arbeit heute!",
        moreDaysStreak: "Noch {0} Tage für eine {1}-Tage-Serie!",
        moreSessions: "Noch {0} Sitzungen für '{1}'!",
        morePoints: "Noch {0} Punkte für '{1}'!",
        todayDone: "Für heute erledigt",
        locked: "Gesperrt",
        sessions: "Sitzungen",
        signIn: "Anmelden",
        signOut: "Abmelden",
        synced: "Synchronisiert",
        syncHint: "Melden Sie sich an, um Ihren Fortschritt auf allen Geräten zu speichern",
        nickname: "Spitzname",
        nicknamePlaceholder: "Ihr Spitzname",
        comingSoon: "Cloud-Synchronisierung kommt bald!",
    }
});


const supportedLocales = languages.map(l => l.locale);

// Priority: 1) cookie, 2) browser language, 3) default (en)
let lang = new Cookies().get("lang");
if (lang && supportedLocales.includes(lang)) {
    translations.setLanguage(lang);
} else {
    // Auto-detect from browser
    const browserLangs = navigator.languages || [navigator.language || 'en'];
    let detected = null;
    for (const bl of browserLangs) {
        const code = bl.split('-')[0].toLowerCase();
        if (supportedLocales.includes(code)) {
            detected = code;
            break;
        }
    }
    if (detected && detected !== 'en') {
        translations.setLanguage(detected);
        // Save to cookie so it persists
        new Cookies().set('lang', detected, { path: '/' });
    }
}

export const strings = translations;
